/* Textured Stickers: the Print Your Own page (sections/ts-pyo-shop.liquid).
   Oct 2026, drawing v11 ("keeping things simple"). Plain JavaScript, no
   build step: edit this file and paste it into the theme as it is.

   Top to bottom:
   - prices come from the product's variants (size and amount in the title)
   - their file is saved to Cloudinary the moment they pick it (_Original
     File), opened right here (PNG, JPG, WEBP, GIF, SVG, PDF, AI), and the
     white box around it comes off (Put it back undoes that)
   - their sticker four ways on our real vinyl texture (two tiles made from
     Amber's shop photos): die cut, circle, square, no border
   - the file check runs by itself: sharpness at the size, small words,
     small details, QR code size. Anything to look at sits at the top with
     numbered marks on the sticker, and their answer rides on the order.
     It never promises to change their artwork: every message offers
     something they can do on the spot.
   - Add to cart: the sticker picture goes to Cloudinary (_Design Image and
     _Sticker Preview), then /cart/add.js, then the cart (through the backs
     coupon when they took the 10%)
   - the help line opens the site's Let's talk! box, already written
   - a PDF quote, an email to purchasing, the soonest date (the portal's
     Production dials, through snippets/ts-lead-times.liquid)

   The heavy helpers (PDF readers, word reader, QR reader, PDF maker) load
   only when they're needed, from pinned versions. */
(function () {
  'use strict';

  var SIZES = ['2.5', '3', '3.5', '4'];
  var STD_QTYS = [50, 100, 250, 500, 750, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000];
  var SHOW_QTYS = [50, 100, 250, 500, 1000];
  var LOOKS = ['die_cut', 'circle', 'square', 'no_border'];
  var LOOK_WORDS = { die_cut: 'die cut', circle: 'circle', square: 'square', no_border: 'no border' };
  var LOOK_CAPS = {
    die_cut: 'Die cut: follows your design\u2019s shape, with a white border.',
    circle: 'Circle: your design inside a clean circle.',
    square: 'Square: your design on a square with rounded corners.',
    no_border: 'No border: cut right at your design\u2019s edge. Very thin bits at the edge can trim a hair.'
  };
  var SHAPE_PROP = {
    die_cut: 'Die cut, white border',
    circle: 'Circle',
    square: 'Square, rounded corners',
    no_border: 'No border, cut right at the edge (print as is)'
  };
  var BAND_IN = 0.125;      /* die cut white border, the studio's thick border */
  var FIELD_R = 200;        /* cut shapes are worked out at 200 px per inch */
  var DECODE_MAX = 2800;    /* biggest side we open a file at */
  var WORK_MAX = 1400;      /* biggest side the cleanup and checks work at */
  var ANALYSIS_MAX = 1200;  /* the small-details check */
  var MAX_BYTES = 25 * 1024 * 1024;
  var PDFIUM_MS = 8000;     /* then pdf.js draws the picture, so a slow PDFium never holds them up */
  var NO_PREVIEW = ['eps', 'ps', 'psd', 'tif', 'tiff', 'heic', 'heif', 'cdr', 'indd'];
  var LIBS = {
    pdf: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.min.js',
    pdfWorker: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js',
    /* same version as the portal's server/package.json, so one reader everywhere */
    pdfium: 'https://cdn.jsdelivr.net/npm/@hyzyla/pdfium@2.1.13/dist/index.esm.cdn.js',
    tess: 'https://cdn.jsdelivr.net/npm/tesseract.js@5.1.1/dist/tesseract.min.js',
    tessWorker: 'https://cdn.jsdelivr.net/npm/tesseract.js@5.1.1/dist/worker.min.js',
    tessCore: 'https://cdn.jsdelivr.net/npm/tesseract.js-core@5.1.1',
    tessLang: 'https://cdn.jsdelivr.net/npm/@tesseract.js-data/eng@1.0.0/4.0.0_best_int',
    jsqr: 'https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.js',
    jspdf: 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js'
  };

  /* =========== small helpers =========== */
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function inch(s) { return String(s).replace(/\.0+$/, '') + '"'; }
  function num(s) { return parseFloat(s); }
  function fmtQty(n) { return Number(n).toLocaleString('en-US'); }
  function round1(n) { return Math.round(n * 10) / 10; }
  function round2(n) { return Math.round(n * 100) / 100; }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function makeCanvas(w, h) {
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w));
    c.height = Math.max(1, Math.round(h));
    return c;
  }
  function extOf(name) { var m = String(name || '').match(/\.([a-z0-9]+)$/i); return m ? m[1].toLowerCase() : ''; }
  var scriptCache = {};
  function loadScript(src) {
    if (scriptCache[src]) return scriptCache[src];
    scriptCache[src] = new Promise(function (ok, bad) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.crossOrigin = 'anonymous';
      s.onload = function () { ok(); };
      s.onerror = function () { delete scriptCache[src]; bad(new Error('could not load ' + src)); };
      document.head.appendChild(s);
    });
    return scriptCache[src];
  }
  function withTimeout(p, ms, what) {
    return Promise.race([p, new Promise(function (ok, bad) { setTimeout(function () { bad(new Error((what || 'step') + ' took too long')); }, ms); })]);
  }

  /* =========== the pixel work (runs in a Web Worker when it can) ===========
     Everything in here is self-contained: the function's own text becomes
     the worker. Ported from the Customer Portal's Sticker Studio
     (server/studio/raster.js, clean.js, shapes.js, words.js) so the
     website and the studio agree. */
  function tspsAnalysis() {
    var INF = 1e20;

    /* exact Euclidean distance transform (Felzenszwalb and Huttenlocher) */
    function dt1d(f, n, d, v, z, nearest) {
      var k = 0, q, s;
      v[0] = 0; z[0] = -INF; z[1] = INF;
      for (q = 1; q < n; q++) {
        s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
        while (s <= z[k]) { k--; s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]); }
        k++; v[k] = q; z[k] = s; z[k + 1] = INF;
      }
      k = 0;
      for (q = 0; q < n; q++) {
        while (z[k + 1] < q) k++;
        d[q] = (q - v[k]) * (q - v[k]) + f[v[k]];
        if (nearest) nearest[q] = v[k];
      }
    }
    /* distance from every pixel to the nearest pixel where site[i] is 1 */
    function edt(W, H, site, wantNearest) {
      var n = Math.max(W, H), x, y;
      var f = new Float64Array(n), d = new Float64Array(n), v = new Int32Array(n), z = new Float64Array(n + 1);
      var near = wantNearest ? new Int32Array(n) : null;
      var colD = new Float64Array(W * H), colNear = wantNearest ? new Int32Array(W * H) : null;
      for (x = 0; x < W; x++) {
        for (y = 0; y < H; y++) f[y] = site[y * W + x] ? 0 : INF;
        dt1d(f, H, d, v, z, near);
        for (y = 0; y < H; y++) { colD[y * W + x] = d[y]; if (colNear) colNear[y * W + x] = near[y]; }
      }
      var out = new Float32Array(W * H), nearest = wantNearest ? new Int32Array(W * H) : null;
      for (y = 0; y < H; y++) {
        var row = y * W;
        for (x = 0; x < W; x++) f[x] = colD[row + x];
        dt1d(f, W, d, v, z, near);
        for (x = 0; x < W; x++) {
          out[row + x] = Math.sqrt(d[x]);
          if (nearest) { var sx = near[x]; nearest[row + x] = colNear[row + sx] * W + sx; }
        }
      }
      return wantNearest ? { dist: out, nearest: nearest } : out;
    }

    function chanDiff(d, i, bg) { return Math.max(Math.abs(d[i] - bg[0]), Math.abs(d[i + 1] - bg[1]), Math.abs(d[i + 2] - bg[2])); }
    function medianOf(a) { var s = a.slice().sort(function (p, q) { return p - q; }); return s.length ? s[s.length >> 1] : 0; }

    /* What's around the edge of the picture: see-through, white, another
       solid color, or busy (a photo, art to the edges). */
    function readBorder(img) {
      var d = img.data, W = img.w, H = img.h, ring = [], x, y, i;
      var step = Math.max(1, Math.floor((W + H) / 3000));
      for (x = 0; x < W; x += step) ring.push(x * 4, ((H - 1) * W + x) * 4);
      for (y = 1; y < H - 1; y += step) ring.push((y * W) * 4, (y * W + W - 1) * 4);
      var clear = 0;
      for (i = 0; i < ring.length; i++) if (d[ring[i] + 3] < 16) clear++;
      if (clear / ring.length > 0.3) return { kind: 'transparent' };
      var solid = ring.filter(function (j) { return d[j + 3] > 200; });
      if (!solid.length) return { kind: 'busy' };
      var bg = [0, 1, 2].map(function (c) { return medianOf(solid.map(function (j) { return d[j + c]; })); });
      var near = 0, noise = 0;
      for (i = 0; i < solid.length; i++) { var cd = chanDiff(d, solid[i], bg); if (cd <= 24) { near++; noise += cd; } }
      var share = near / solid.length;
      var white = Math.min(bg[0], bg[1], bg[2]) >= 215 && Math.max(bg[0], bg[1], bg[2]) - Math.min(bg[0], bg[1], bg[2]) <= 25;
      if (share >= 0.6) return { kind: white ? 'white' : 'solid', color: bg, share: share, noise: near ? noise / near : 0 };
      return { kind: 'busy' };
    }

    /* Take off a solid background that touches the edges (a magic wand
       from the edges, like Morgan's Photoshop step): white letters and the
       white middle of a gear stay. */
    function removeEdgeBackground(img, bg, noise) {
      var d = img.data, W = img.w, H = img.h, n = W * H;
      var tol = Math.max(14, Math.min(36, Math.round(10 + noise * 3)));
      var isBg = new Uint8Array(n), stack = new Int32Array(n), sp = 0, x, y;
      function push(p) {
        if (isBg[p]) return;
        var i = p * 4;
        if (d[i + 3] < 16 || chanDiff(d, i, bg) <= tol) { isBg[p] = 1; stack[sp++] = p; }
      }
      for (x = 0; x < W; x++) { push(x); push((H - 1) * W + x); }
      for (y = 0; y < H; y++) { push(y * W); push(y * W + W - 1); }
      while (sp) {
        var p = stack[--sp];
        x = p % W; y = (p - x) / W;
        if (x > 0) push(p - 1);
        if (x < W - 1) push(p + 1);
        if (y > 0) push(p - W);
        if (y < H - 1) push(p + W);
      }
      var removed = 0;
      for (var q = 0; q < n; q++) removed += isBg[q];
      return { img: softEdges(img, isBg, bg), removedShare: removed / n };
    }
    /* Soft edges where the white came off: each edge pixel's alpha is how
       far it sits from the white toward the ink a few steps in, and the
       white is taken back out of its color (no white halo). */
    function softEdges(img, isBg, bg) {
      var W = img.w, H = img.h, n = W * H, d = img.data, p;
      var fromBg = edt(W, H, isBg, true);
      var coreSite = new Uint8Array(n);
      for (p = 0; p < n; p++) coreSite[p] = (!isBg[p] && fromBg.dist[p] >= 3) ? 1 : 0;
      var core = edt(W, H, coreSite, true);
      var o = new Uint8ClampedArray(n * 4);
      for (p = 0; p < n; p++) {
        var i = p * 4;
        if (isBg[p]) continue;
        o[i] = d[i]; o[i + 1] = d[i + 1]; o[i + 2] = d[i + 2]; o[i + 3] = d[i + 3];
        if (fromBg.dist[p] >= 3) continue;
        var q = core.dist[p] <= 6 ? core.nearest[p] * 4 : -1;
        if (q < 0) {
          var x = p % W, y = (p - x) / W, best = -1;
          for (var dy = -2; dy <= 2; dy++) {
            for (var dx = -2; dx <= 2; dx++) {
              var xx = x + dx, yy = y + dy;
              if (xx < 0 || yy < 0 || xx >= W || yy >= H || isBg[yy * W + xx]) continue;
              var j = (yy * W + xx) * 4, dj = chanDiff(d, j, bg);
              if (dj > best) { best = dj; q = j; }
            }
          }
          if (q < 0) continue;
        }
        var span = chanDiff(d, q, bg);
        if (span < 24) continue;
        var a = Math.min(1, chanDiff(d, i, bg) / span);
        if (a < 0.06) a = 0;
        if (a < 1) {
          for (var c = 0; c < 3; c++) o[i + c] = a > 0 ? (d[i + c] - (1 - a) * bg[c]) / a : 0;
          o[i + 3] = Math.round(a * d[i + 3]);
        }
      }
      return { w: W, h: H, data: o };
    }
    function alphaBox(img, min) {
      var W = img.w, H = img.h, d = img.data, x0 = W, y0 = H, x1 = -1, y1 = -1;
      for (var y = 0; y < H; y++) {
        var row = y * W * 4;
        for (var x = 0; x < W; x++) {
          if (d[row + x * 4 + 3] > min) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; y1 = y; }
        }
      }
      return x1 < 0 ? null : { x: x0, y: y0, w: x1 - x0 + 1, h: y1 - y0 + 1 };
    }
    function crop(img, b) {
      var out = new Uint8ClampedArray(b.w * b.h * 4);
      for (var y = 0; y < b.h; y++) {
        var s = ((b.y + y) * img.w + b.x) * 4;
        out.set(img.data.subarray(s, s + b.w * 4), y * b.w * 4);
      }
      return { w: b.w, h: b.h, data: out };
    }

    /* Their file, ready to use: the white box off (when there is one) and
       the empty space trimmed. Both versions come back: clean, and raw
       (for "Put it back"). Boxes are where each sits in the full picture. */
    function prepare(o) {
      var img = { w: o.w, h: o.h, data: o.data };
      var border = readBorder(img), clean = img, removed = false, share = 0;
      if (border.kind === 'white') {
        var r = removeEdgeBackground(img, border.color, border.noise || 0);
        if (r.removedShare > 0.005) { clean = r.img; removed = true; share = r.removedShare; }
      }
      var cb = alphaBox(clean, 8), rb = alphaBox(img, 8);
      if (!cb || !rb) return { empty: true, border: border };
      var c = crop(clean, cb), rw = crop(img, rb);
      c.box = cb; rw.box = rb;
      return { empty: false, border: border, removed: removed, share: share, clean: c, raw: rw };
    }

    /* -- masks -- */
    function dilateM(mask, W, H, r) {
      if (r <= 0) return mask.slice();
      var dist = edt(W, H, mask, false), out = new Uint8Array(W * H);
      for (var i = 0; i < out.length; i++) out[i] = dist[i] <= r ? 1 : 0;
      return out;
    }
    function erodeM(mask, W, H, r) {
      if (r <= 0) return mask.slice();
      var inv = new Uint8Array(W * H), i;
      for (i = 0; i < inv.length; i++) inv[i] = mask[i] ? 0 : 1;
      var dist = edt(W, H, inv, false), out = new Uint8Array(W * H);
      for (i = 0; i < out.length; i++) out[i] = mask[i] && dist[i] > r ? 1 : 0;
      return out;
    }
    function fillHoles(mask, W, H) {
      var outside = new Uint8Array(W * H), stack = new Int32Array(W * H), sp = 0, x, y;
      function push(i) { if (!mask[i] && !outside[i]) { outside[i] = 1; stack[sp++] = i; } }
      for (x = 0; x < W; x++) { push(x); push((H - 1) * W + x); }
      for (y = 0; y < H; y++) { push(y * W); push(y * W + W - 1); }
      while (sp) {
        var i = stack[--sp];
        x = i % W; y = (i - x) / W;
        if (x > 0) push(i - 1);
        if (x < W - 1) push(i + 1);
        if (y > 0) push(i - W);
        if (y < H - 1) push(i + W);
      }
      var out = new Uint8Array(W * H);
      for (var j = 0; j < out.length; j++) out[j] = outside[j] ? 0 : 1;
      return out;
    }
    function components(mask, W, H) {
      var labels = new Int32Array(W * H), sizes = [0], count = 0, stack = new Int32Array(W * H);
      for (var start = 0; start < labels.length; start++) {
        if (!mask[start] || labels[start]) continue;
        count++;
        var size = 0, sp = 0;
        labels[start] = count; stack[sp++] = start;
        while (sp) {
          var i = stack[--sp];
          size++;
          var x = i % W, y = (i - x) / W;
          for (var dy = -1; dy <= 1; dy++) {
            var yy = y + dy;
            if (yy < 0 || yy >= H) continue;
            for (var dx = -1; dx <= 1; dx++) {
              var xx = x + dx;
              if (xx < 0 || xx >= W || (!dx && !dy)) continue;
              var j = yy * W + xx;
              if (mask[j] && !labels[j]) { labels[j] = count; stack[sp++] = j; }
            }
          }
        }
        sizes.push(size);
      }
      return { count: count, labels: labels, sizes: sizes };
    }
    /* Separate pieces (a logo and the words beside it) get joined by short
       bridges along the shortest links, so the cut stays one shape. */
    function bridgePieces(mask, W, H, comp, radius) {
      var count = comp.count, labels = comp.labels, l, k;
      var edgePts = [];
      for (l = 0; l <= count; l++) edgePts.push([]);
      for (var y = 1; y < H - 1; y++) {
        for (var x = 1; x < W - 1; x++) {
          var i = y * W + x, lb = labels[i];
          if (!lb) continue;
          if (!labels[i - 1] || !labels[i + 1] || !labels[i - W] || !labels[i + W]) edgePts[lb].push(x, y);
        }
      }
      for (l = 1; l <= count; l++) {
        var pts = edgePts[l], step = Math.max(1, Math.floor(pts.length / 2 / 150)), keep = [];
        for (k = 0; k < pts.length; k += 2 * step) keep.push(pts[k], pts[k + 1]);
        edgePts[l] = keep;
      }
      var pairs = [];
      for (var a = 1; a <= count; a++) {
        for (var b = a + 1; b <= count; b++) {
          var best = Infinity, pa = -1, pb = -1, A = edgePts[a], B = edgePts[b];
          for (var s = 0; s < A.length; s += 2) {
            for (var t = 0; t < B.length; t += 2) {
              var dd = (A[s] - B[t]) * (A[s] - B[t]) + (A[s + 1] - B[t + 1]) * (A[s + 1] - B[t + 1]);
              if (dd < best) { best = dd; pa = s; pb = t; }
            }
          }
          if (pa >= 0) pairs.push({ a: a, b: b, d: best, x1: A[pa], y1: A[pa + 1], x2: B[pb], y2: B[pb + 1] });
        }
      }
      pairs.sort(function (p, q) { return p.d - q.d; });
      var parent = [];
      for (l = 0; l <= count; l++) parent.push(l);
      function find(i) { while (parent[i] !== i) { parent[i] = parent[parent[i]]; i = parent[i]; } return i; }
      var out = mask.slice();
      for (k = 0; k < pairs.length; k++) {
        var p = pairs[k], ra = find(p.a), rb = find(p.b);
        if (ra === rb) continue;
        parent[ra] = rb;
        var minX = Math.max(0, Math.floor(Math.min(p.x1, p.x2) - radius - 1)), maxX = Math.min(W - 1, Math.ceil(Math.max(p.x1, p.x2) + radius + 1));
        var minY = Math.max(0, Math.floor(Math.min(p.y1, p.y2) - radius - 1)), maxY = Math.min(H - 1, Math.ceil(Math.max(p.y1, p.y2) + radius + 1));
        var ddx = p.x2 - p.x1, ddy = p.y2 - p.y1, len2 = ddx * ddx + ddy * ddy || 1;
        for (var yy = minY; yy <= maxY; yy++) {
          for (var xx = minX; xx <= maxX; xx++) {
            var tt = Math.max(0, Math.min(1, ((xx - p.x1) * ddx + (yy - p.y1) * ddy) / len2));
            var cx = p.x1 + tt * ddx, cy = p.y1 + tt * ddy;
            if ((xx - cx) * (xx - cx) + (yy - cy) * (yy - cy) <= radius * radius) out[yy * W + xx] = 1;
          }
        }
      }
      return out;
    }
    /* Gaussian-ish blur: three box passes each way (Kovesi). */
    function blurField(field, W, H, sigma) {
      if (sigma <= 0.3) return Float32Array.from(field);
      var n = 3, wIdeal = Math.sqrt((12 * sigma * sigma / n) + 1), wl = Math.floor(wIdeal);
      if (wl % 2 === 0) wl--;
      var wu = wl + 2, m = Math.round((12 * sigma * sigma - n * wl * wl - 4 * n * wl - 3 * n) / (-4 * wl - 4));
      var a = Float32Array.from(field), b = new Float32Array(field.length);
      for (var i = 0; i < n; i++) {
        var r = ((i < m ? wl : wu) - 1) / 2;
        boxH(a, b, W, H, r);
        boxV(b, a, W, H, r);
      }
      return a;
    }
    function boxH(src, dst, w, h, r) {
      var iarr = 1 / (r + r + 1);
      for (var y = 0; y < h; y++) {
        var row = y * w, acc = 0, k;
        for (k = -r - 1; k < r; k++) acc += src[row + Math.min(w - 1, Math.max(0, k))];
        for (var x = 0; x < w; x++) {
          acc += src[row + Math.min(w - 1, x + r)] - src[row + Math.max(0, x - r - 1)];
          dst[row + x] = acc * iarr;
        }
      }
    }
    function boxV(src, dst, w, h, r) {
      var iarr = 1 / (r + r + 1);
      for (var x = 0; x < w; x++) {
        var acc = 0, k;
        for (k = -r - 1; k < r; k++) acc += src[Math.min(h - 1, Math.max(0, k)) * w + x];
        for (var y = 0; y < h; y++) {
          acc += src[Math.min(h - 1, y + r) * w + x] - src[Math.max(0, y - r - 1) * w + x];
          dst[y * w + x] = acc * iarr;
        }
      }
    }
    /* the art's alpha (0..255) sampled onto the working grid, as 0/1 */
    function sampleMask(alpha, w0, h0, aw, ah, W, H, ox, oy) {
      var mask = new Uint8Array(W * H), sx = w0 / aw, sy = h0 / ah;
      for (var y = 0; y < ah; y++) {
        var fy = Math.min(h0 - 1.001, Math.max(0, (y + 0.5) * sy - 0.5)), y0 = Math.floor(fy), ty = fy - y0;
        for (var x = 0; x < aw; x++) {
          var fx = Math.min(w0 - 1.001, Math.max(0, (x + 0.5) * sx - 0.5)), x0 = Math.floor(fx), tx = fx - x0;
          var i = y0 * w0 + x0;
          var v = alpha[i] * (1 - tx) * (1 - ty) + alpha[i + 1] * tx * (1 - ty) + alpha[i + w0] * (1 - tx) * ty + alpha[i + w0 + 1] * tx * ty;
          if (v >= 127.5) mask[(y + oy) * W + (x + ox)] = 1;
        }
      }
      return mask;
    }
    function fieldBox(field, W, H, t) {
      var x0 = W, y0 = H, x1 = -1, y1 = -1;
      for (var y = 0; y < H; y++) {
        var row = y * W;
        for (var x = 0; x < W; x++) if (field[row + x] >= t) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; y1 = y; }
      }
      return x1 < 0 ? null : { x0: x0, y0: y0, x1: x1 + 1, y1: y1 + 1 };
    }
    /* The cut for a die cut (band > 0) or a no-border cut (band 0) at a
       size: the art's silhouette grown by the band, inlets narrower than
       about a fifth of an inch filled (a blade can't follow them), holes
       filled, pieces bridged, edges smoothed. Like shapes.js
       dieCutOutline, but it hands back the smooth shape itself. */
    function cutField(o) {
      var R = o.R, bandIn = o.bandIn, sizeIn = o.sizeIn, longArt = Math.max(o.w, o.h);
      var closeIn = Math.max(0.1, bandIn * 0.8);
      var artLongIn = Math.max(sizeIn * 0.3, sizeIn - 2 * bandIn);
      var result = null;
      for (var iter = 0; iter < 4; iter++) {
        var scale = artLongIn * R / longArt;
        var aw = Math.max(2, Math.round(o.w * scale)), ah = Math.max(2, Math.round(o.h * scale));
        var band = bandIn * R, closeR = closeIn * R;
        var margin = Math.ceil(band + closeR + 0.12 * R) + 2;
        var W = aw + 2 * margin, H = ah + 2 * margin;
        var mask = sampleMask(o.alpha, o.w, o.h, aw, ah, W, H, margin, margin);
        var shape = erodeM(dilateM(mask, W, H, band + closeR), W, H, closeR);
        shape = fillHoles(shape, W, H);
        var comp = components(shape, W, H), grow = 0;
        while (comp.count > 40 && grow < 4) {
          grow++;
          shape = fillHoles(erodeM(dilateM(shape, W, H, closeR + 0.1 * R * grow), W, H, closeR), W, H);
          comp = components(shape, W, H);
        }
        var pieces = comp.count;
        if (comp.count > 1) {
          shape = bridgePieces(shape, W, H, comp, Math.max(band, 0.06 * R));
          shape = fillHoles(erodeM(dilateM(shape, W, H, closeR), W, H, closeR), W, H);
        }
        var fl = new Float32Array(W * H);
        for (var i = 0; i < fl.length; i++) fl[i] = shape[i];
        var field = blurField(fl, W, H, (band > 0 ? 0.02 : 0.006) * R);
        var bb = fieldBox(field, W, H, 0.5);
        if (!bb) return null;
        var longPx = Math.max(bb.x1 - bb.x0, bb.y1 - bb.y0);
        var ratio = sizeIn * R / longPx;
        result = { field: field, W: W, H: H, R: R, art: { x: margin, y: margin, w: aw, h: ah }, cut: bb, pieces: pieces, sizeIn: sizeIn, bandIn: bandIn };
        if (Math.abs(ratio - 1) < 0.006) break;
        artLongIn *= ratio;
      }
      return result;
    }
    /* Smallest circle around the art's solid pixels (hull + Welzl), so
       round art fills a circle sticker. */
    function enclosingCircle(o) {
      var W = o.w, H = o.h, a = o.alpha, pts = [], step = Math.max(1, Math.floor(Math.max(W, H) / 600));
      for (var y = 0; y < H; y += step) {
        var first = -1, last = -1;
        for (var x = 0; x < W; x++) if (a[y * W + x] >= 128) { if (first < 0) first = x; last = x; }
        if (first >= 0) pts.push([first, y], [last + 1, y], [first, y + step], [last + 1, y + step]);
      }
      if (!pts.length) return { cx: W / 2, cy: H / 2, r: Math.sqrt(W * W + H * H) / 2 };
      pts.sort(function (p, q) { return p[0] - q[0] || p[1] - q[1]; });
      function cross(o2, p, q) { return (p[0] - o2[0]) * (q[1] - o2[1]) - (p[1] - o2[1]) * (q[0] - o2[0]); }
      var lower = [], upper = [], i;
      for (i = 0; i < pts.length; i++) { while (lower.length >= 2 && cross(lower[lower.length - 2], lower[lower.length - 1], pts[i]) <= 0) lower.pop(); lower.push(pts[i]); }
      for (i = pts.length - 1; i >= 0; i--) { while (upper.length >= 2 && cross(upper[upper.length - 2], upper[upper.length - 1], pts[i]) <= 0) upper.pop(); upper.push(pts[i]); }
      var hull = lower.slice(0, -1).concat(upper.slice(0, -1));
      var seed = 7;
      for (i = hull.length - 1; i > 0; i--) { seed = (seed * 16807) % 2147483647; var j = seed % (i + 1); var t = hull[i]; hull[i] = hull[j]; hull[j] = t; }
      function inC(c, p) { return Math.sqrt((p[0] - c.cx) * (p[0] - c.cx) + (p[1] - c.cy) * (p[1] - c.cy)) <= c.r + 1e-7; }
      function two(p, q) { return { cx: (p[0] + q[0]) / 2, cy: (p[1] + q[1]) / 2, r: Math.sqrt((p[0] - q[0]) * (p[0] - q[0]) + (p[1] - q[1]) * (p[1] - q[1])) / 2 }; }
      function three(p, q, s) {
        var d = 2 * (p[0] * (q[1] - s[1]) + q[0] * (s[1] - p[1]) + s[0] * (p[1] - q[1]));
        if (Math.abs(d) < 1e-12) return null;
        var p2 = p[0] * p[0] + p[1] * p[1], q2 = q[0] * q[0] + q[1] * q[1], s2 = s[0] * s[0] + s[1] * s[1];
        var ux = (p2 * (q[1] - s[1]) + q2 * (s[1] - p[1]) + s2 * (p[1] - q[1])) / d;
        var uy = (p2 * (s[0] - q[0]) + q2 * (p[0] - s[0]) + s2 * (q[0] - p[0])) / d;
        return { cx: ux, cy: uy, r: Math.sqrt((p[0] - ux) * (p[0] - ux) + (p[1] - uy) * (p[1] - uy)) };
      }
      var c = { cx: hull[0][0], cy: hull[0][1], r: 0 };
      for (i = 1; i < hull.length; i++) {
        if (inC(c, hull[i])) continue;
        c = { cx: hull[i][0], cy: hull[i][1], r: 0 };
        for (var jj = 0; jj < i; jj++) {
          if (inC(c, hull[jj])) continue;
          c = two(hull[i], hull[jj]);
          for (var k = 0; k < jj; k++) { if (inC(c, hull[k])) continue; c = three(hull[i], hull[jj], hull[k]) || c; }
        }
      }
      return c;
    }

    /* -- small details: lines, dots and fine patterns thinner than a
       square of D px can fit in (a morphological top-hat on brightness,
       both ways: dark on light and light on dark). Each piece's width is
       then measured properly (half its contrast, then distance to its
       edge along its middle), so diagonal lines aren't over-counted. -- */
    function morph1D(src, W, H, k, isMax, horizontal) {
      var out = new Uint8Array(W * H), n = horizontal ? W : H, lines = horizontal ? H : W;
      var r = (k - 1) >> 1, m = n + 2 * r;
      var pad = new Uint8Array(m), g = new Uint8Array(m), hb = new Uint8Array(m), i;
      for (var L = 0; L < lines; L++) {
        var base = horizontal ? L * W : L, step = horizontal ? 1 : W;
        for (i = 0; i < m; i++) { var t = i - r; if (t < 0) t = 0; else if (t >= n) t = n - 1; pad[i] = src[base + t * step]; }
        for (i = 0; i < m; i++) {
          if (i % k === 0) g[i] = pad[i];
          else g[i] = isMax ? (pad[i] > g[i - 1] ? pad[i] : g[i - 1]) : (pad[i] < g[i - 1] ? pad[i] : g[i - 1]);
        }
        for (i = m - 1; i >= 0; i--) {
          if (i === m - 1 || (i + 1) % k === 0) hb[i] = pad[i];
          else hb[i] = isMax ? (pad[i] > hb[i + 1] ? pad[i] : hb[i + 1]) : (pad[i] < hb[i + 1] ? pad[i] : hb[i + 1]);
        }
        for (var x = 0; x < n; x++) {
          var a = hb[x], b = g[x + 2 * r];
          out[base + x * step] = isMax ? (a > b ? a : b) : (a < b ? a : b);
        }
      }
      return out;
    }
    function morph2D(src, W, H, k, isMax) { return morph1D(morph1D(src, W, H, k, isMax, true), W, H, k, isMax, false); }
    function details(o) {
      var W = o.w, H = o.h, L = o.lum, A = o.alpha, n = W * H, D = o.D, cmin = o.cmin, i, x, y;
      var closing = morph2D(morph2D(L, W, H, D, true), W, H, D, false);
      var opening = morph2D(morph2D(L, W, H, D, false), W, H, D, true);
      var feats = [];
      for (var pol = 0; pol < 2; pol++) {
        var T = new Uint8Array(n);
        for (i = 0; i < n; i++) T[i] = pol === 0 ? closing[i] - L[i] : L[i] - opening[i];
        var cand = new Uint8Array(n), lo = cmin >> 1;
        for (i = 0; i < n; i++) cand[i] = T[i] > lo ? 1 : 0;
        var comp = components(cand, W, H), cnt = comp.count, labels = comp.labels;
        if (!cnt) continue;
        var peak = new Uint8Array(cnt + 1);
        for (i = 0; i < n; i++) { var l = labels[i]; if (l && T[i] > peak[l]) peak[l] = T[i]; }
        var mask = new Uint8Array(n), inv = new Uint8Array(n);
        for (i = 0; i < n; i++) { var l2 = labels[i]; mask[i] = (l2 && peak[l2] >= cmin && T[i] * 2 >= peak[l2]) ? 1 : 0; inv[i] = mask[i] ? 0 : 1; }
        var dist = edt(W, H, inv, false);
        var area = new Int32Array(cnt + 1), ridge = new Int32Array(cnt + 1), wsum = new Float64Array(cnt + 1), w2sum = new Float64Array(cnt + 1), lsum = new Float64Array(cnt + 1);
        var bx0 = new Int32Array(cnt + 1), by0 = new Int32Array(cnt + 1), bx1 = new Int32Array(cnt + 1), by1 = new Int32Array(cnt + 1);
        for (i = 0; i <= cnt; i++) { bx0[i] = W; by0[i] = H; bx1[i] = -1; by1[i] = -1; }
        for (y = 0; y < H; y++) {
          for (x = 0; x < W; x++) {
            var p = y * W + x;
            if (!mask[p]) continue;
            var lb = labels[p];
            area[lb]++;
            lsum[lb] += L[p];
            if (x < bx0[lb]) bx0[lb] = x; if (x > bx1[lb]) bx1[lb] = x;
            if (y < by0[lb]) by0[lb] = y; if (y > by1[lb]) by1[lb] = y;
            var dv = dist[p], isRidge = true;
            for (var dy = -1; dy <= 1 && isRidge; dy++) {
              var yy = y + dy;
              if (yy < 0 || yy >= H) continue;
              for (var dx = -1; dx <= 1; dx++) {
                var xx = x + dx;
                if (xx < 0 || xx >= W || (!dx && !dy)) continue;
                if (dist[yy * W + xx] > dv) { isRidge = false; break; }
              }
            }
            if (isRidge) { var wv = Math.max(1, 2 * dv - 0.5); ridge[lb]++; wsum[lb] += wv; w2sum[lb] += wv * wv; }
          }
        }
        /* A real thin line has lighter (or darker) color on BOTH sides. The
           rounded corner of a big solid shape fools the square test above:
           a thin sliver along its curve, with the shape's own color on one
           side. So look at a ring a couple of pixels around each piece:
           when much of it is the piece's own color, it's the edge of
           something bigger, not a thin line. */
        var near = edt(W, H, mask, true), ringN = new Int32Array(cnt + 1), ringSame = new Int32Array(cnt + 1);
        for (i = 0; i < n; i++) {
          if (mask[i]) continue;
          var od = near.dist[i];
          if (od <= 1.2 || od > 3.6) continue;
          var lr = labels[near.nearest[i]];
          if (!lr || !area[lr]) continue;
          ringN[lr]++;
          var featL = lsum[lr] / area[lr], cc = peak[lr];
          if (pol === 0 ? L[i] < featL + cc * 0.5 : L[i] > featL - cc * 0.5) ringSame[lr]++;
        }
        for (l = 1; l <= cnt; l++) {
          if (area[l] < 3 || !ridge[l]) continue;
          if (ringN[l] && ringSame[l] / ringN[l] > 0.3) continue;
          var wpx = wsum[l] / ridge[l];
          /* a line keeps about the same width along its length; a notch
             (the V inside an M, the gap where two shapes meet) tapers */
          var spread = ridge[l] > 3 ? Math.sqrt(Math.max(0, w2sum[l] / ridge[l] - wpx * wpx)) / wpx : 0;
          if (spread > 0.34 && area[l] / wpx > 3 * wpx) continue;
          feats.push({ x0: bx0[l], y0: by0[l], x1: bx1[l] + 1, y1: by1[l] + 1, area: area[l], w: wpx, len: area[l] / wpx, pol: pol, c: peak[l], spread: spread });
        }
      }
      feats.sort(function (p, q) { return q.area - p.area; });
      if (feats.length > 4000) feats.length = 4000;
      /* photo-like art (lots of soft in-between shading) skips this check,
         and so does a photo inside a design (a dog's fur, a face): fine
         detail in a photo is expected and prints like a photo. Each 16 px
         block gets its own yes or no. */
      var B = 16, GW = Math.ceil(W / B), GH = Math.ceil(H / B), gOp = new Int32Array(GW * GH), gMid = new Int32Array(GW * GH);
      var opaque = 0, mid = 0;
      for (y = 0; y < H - 1; y++) {
        for (x = 0; x < W - 1; x++) {
          var q = y * W + x;
          if (A[q] < 200 || A[q + 1] < 200 || A[q + W] < 200) continue;
          var gi = ((y / B) | 0) * GW + ((x / B) | 0);
          gOp[gi]++; opaque++;
          var gr = Math.abs(L[q + 1] - L[q]) + Math.abs(L[q + W] - L[q]);
          if (gr > 5 && gr <= 40) { gMid[gi]++; mid++; }
        }
      }
      var photoGrid = new Uint8Array(GW * GH);
      for (i = 0; i < photoGrid.length; i++) photoGrid[i] = gOp[i] > B * B * 0.5 && gMid[i] / gOp[i] > 0.3 ? 1 : 0;
      /* a block counts only when its neighbors agree (a single busy block
         is usually just an edge of the drawing) */
      var photoSmooth = new Uint8Array(GW * GH);
      for (var gy = 0; gy < GH; gy++) {
        for (var gx = 0; gx < GW; gx++) {
          if (!photoGrid[gy * GW + gx]) continue;
          var nb = 0;
          for (var oy = -1; oy <= 1; oy++) for (var oxx = -1; oxx <= 1; oxx++) {
            var yy2 = gy + oy, xx2 = gx + oxx;
            if (yy2 >= 0 && yy2 < GH && xx2 >= 0 && xx2 < GW && photoGrid[yy2 * GW + xx2]) nb++;
          }
          photoSmooth[gy * GW + gx] = nb >= 5 ? 1 : 0;
        }
      }
      return { feats: feats, photo: opaque ? mid / opaque : 0, w: W, h: H, photoGrid: photoSmooth, gw: GW, gb: B };
    }

    /* -- QR codes: the three corner squares (1:1:3:1:1 runs, checked
       across and down), grouped into an L. Finds codes even when they're
       too small to read. -- */
    function ratioOk(c) {
      var total = c[0] + c[1] + c[2] + c[3] + c[4];
      if (total < 7) return 0;
      var m = total / 7, v = m * 0.7;
      return Math.abs(m - c[0]) < v && Math.abs(m - c[1]) < v && Math.abs(3 * m - c[2]) < 3 * v && Math.abs(m - c[3]) < v && Math.abs(m - c[4]) < v ? m : 0;
    }
    function crossV(bin, W, H, x, y, maxRun) {
      var c = [0, 0, 0, 0, 0], yy = y;
      if (!bin[y * W + x]) return null;
      while (yy >= 0 && bin[yy * W + x]) { c[2]++; yy--; }
      while (yy >= 0 && !bin[yy * W + x] && c[1] <= maxRun) { c[1]++; yy--; }
      if (yy < 0 || c[1] > maxRun) return null;
      while (yy >= 0 && bin[yy * W + x] && c[0] <= maxRun) { c[0]++; yy--; }
      if (c[0] > maxRun) return null;
      yy = y + 1;
      while (yy < H && bin[yy * W + x]) { c[2]++; yy++; }
      if (yy >= H) return null;
      while (yy < H && !bin[yy * W + x] && c[3] <= maxRun) { c[3]++; yy++; }
      if (yy >= H || c[3] > maxRun) return null;
      while (yy < H && bin[yy * W + x] && c[4] <= maxRun) { c[4]++; yy++; }
      if (c[4] > maxRun) return null;
      var m = ratioOk(c);
      if (!m) return null;
      return { m: m, cy: (yy - c[4] - c[3]) - c[2] / 2 };
    }
    function qrFind(o) {
      var W = o.w, H = o.h, L = o.lum, n = W * H, i, x, y;
      var bin = new Uint8Array(n);
      for (i = 0; i < n; i++) bin[i] = L[i] < 128 ? 1 : 0;
      var cand = [];
      for (y = 0; y < H; y++) {
        var row = y * W, colors = [], starts = [], lens = [];
        x = 0;
        while (x < W) { var cl = bin[row + x], s = x; while (x < W && bin[row + x] === cl) x++; colors.push(cl); starts.push(s); lens.push(x - s); }
        for (i = 0; i + 4 < colors.length; i++) {
          if (colors[i] !== 1) continue;
          var m = ratioOk([lens[i], lens[i + 1], lens[i + 2], lens[i + 3], lens[i + 4]]);
          if (!m) continue;
          var cx = starts[i + 2] + lens[i + 2] / 2;
          var v = crossV(bin, W, H, Math.floor(cx), y, lens[i + 2] + 2);
          if (!v || Math.abs(v.m - m) > 0.5 * Math.max(v.m, m)) continue;
          cand.push({ x: cx, y: v.cy, m: (m + v.m) / 2 });
        }
        if (cand.length > 20000) break;
      }
      /* group the hits that belong to one corner square */
      var groups = [];
      for (i = 0; i < cand.length; i++) {
        var cd = cand[i], hit = null;
        for (var g = 0; g < groups.length; g++) {
          var G = groups[g], gm = G.m / G.n;
          if (Math.abs(G.x / G.n - cd.x) < 2 * gm && Math.abs(G.y / G.n - cd.y) < 2 * gm && Math.abs(gm - cd.m) < 0.6 * gm) { hit = G; break; }
        }
        if (hit) { hit.x += cd.x; hit.y += cd.y; hit.m += cd.m; hit.n++; }
        else if (groups.length < 400) groups.push({ x: cd.x, y: cd.y, m: cd.m, n: 1 });
      }
      var centers = groups.filter(function (G) { return G.n >= 2; }).map(function (G) { return { x: G.x / G.n, y: G.y / G.n, m: G.m / G.n, n: G.n }; });
      centers.sort(function (p, q) { return q.n - p.n; });
      if (centers.length > 40) centers.length = 40;
      var found = [];
      function dst(p, q) { return Math.sqrt((p.x - q.x) * (p.x - q.x) + (p.y - q.y) * (p.y - q.y)); }
      for (var a = 0; a < centers.length; a++) {
        for (var b = a + 1; b < centers.length; b++) {
          for (var c = b + 1; c < centers.length; c++) {
            var P = [centers[a], centers[b], centers[c]];
            var mm = [P[0].m, P[1].m, P[2].m], mmax = Math.max.apply(null, mm), mmin = Math.min.apply(null, mm);
            if (mmax / mmin > 1.45) continue;
            var dAB = dst(P[0], P[1]), dAC = dst(P[0], P[2]), dBC = dst(P[1], P[2]);
            var corner, p1, p2, leg1, leg2, hyp;
            if (dBC >= dAB && dBC >= dAC) { corner = P[0]; p1 = P[1]; p2 = P[2]; leg1 = dAB; leg2 = dAC; hyp = dBC; }
            else if (dAC >= dAB && dAC >= dBC) { corner = P[1]; p1 = P[0]; p2 = P[2]; leg1 = dAB; leg2 = dBC; hyp = dAC; }
            else { corner = P[2]; p1 = P[0]; p2 = P[1]; leg1 = dAC; leg2 = dBC; hyp = dAB; }
            var legs = (leg1 + leg2) / 2, mod = (mm[0] + mm[1] + mm[2]) / 3;
            if (Math.abs(leg1 - leg2) > 0.2 * legs) continue;
            if (Math.abs(hyp - legs * Math.SQRT2) > 0.15 * hyp) continue;
            var modules = legs / mod + 7;
            if (modules < 17 || modules > 185) continue;
            var side = legs + 7 * mod, ccx = (p1.x + p2.x) / 2, ccy = (p1.y + p2.y) / 2;
            var dupe = false;
            for (var f = 0; f < found.length; f++) if (Math.abs(found[f].cx - ccx) < side / 3 && Math.abs(found[f].cy - ccy) < side / 3) { dupe = true; break; }
            if (!dupe) found.push({ cx: ccx, cy: ccy, side: side, module: mod, modules: modules });
          }
        }
      }
      return found;
    }
    /* Read QR codes with jsQR (full picture, then each place the corner
       squares point at, blown up), for their exact corners. */
    function jsqrScan(o) {
      try {
        if (typeof jsQR !== 'function' && typeof importScripts === 'function') importScripts(o.url);
      } catch (e) { return { ok: false, codes: [] }; }
      if (typeof jsQR !== 'function') return { ok: false, codes: [] };
      var codes = [];
      function read(rgba, w, h, ox, oy, k) {
        var r = null;
        try { r = jsQR(rgba, w, h, { inversionAttempts: 'attemptBoth' }); } catch (e) { r = null; }
        if (!r || !r.location) return;
        var L = r.location, pts = [L.topLeftCorner, L.topRightCorner, L.bottomRightCorner, L.bottomLeftCorner];
        var xs = pts.map(function (p) { return ox + p.x / k; }), ys = pts.map(function (p) { return oy + p.y / k; });
        var side = (Math.sqrt(Math.pow(xs[1] - xs[0], 2) + Math.pow(ys[1] - ys[0], 2)) + Math.sqrt(Math.pow(xs[3] - xs[0], 2) + Math.pow(ys[3] - ys[0], 2))) / 2;
        codes.push({ cx: (xs[0] + xs[2]) / 2, cy: (ys[0] + ys[2]) / 2, side: side, decoded: true });
      }
      read(o.rgba, o.w, o.h, 0, 0, 1);
      (o.crops || []).forEach(function (cr) {
        var x0 = Math.max(0, Math.floor(cr.x)), y0 = Math.max(0, Math.floor(cr.y));
        var x1 = Math.min(o.w, Math.ceil(cr.x + cr.w)), y1 = Math.min(o.h, Math.ceil(cr.y + cr.h));
        var cw = x1 - x0, ch = y1 - y0;
        if (cw < 8 || ch < 8) return;
        var k = Math.max(1, Math.min(8, 480 / Math.max(cw, ch))), w = Math.round(cw * k), h = Math.round(ch * k);
        var out = new Uint8ClampedArray(w * h * 4);
        for (var y = 0; y < h; y++) {
          var fy = Math.min(ch - 1.001, Math.max(0, (y + 0.5) / k - 0.5)), yi = Math.floor(fy), ty = fy - yi;
          for (var x = 0; x < w; x++) {
            var fx = Math.min(cw - 1.001, Math.max(0, (x + 0.5) / k - 0.5)), xi = Math.floor(fx), tx = fx - xi;
            var i00 = ((y0 + yi) * o.w + x0 + xi) * 4, i10 = i00 + 4, i01 = i00 + o.w * 4, i11 = i01 + 4, di = (y * w + x) * 4;
            for (var c = 0; c < 3; c++) {
              out[di + c] = o.rgba[i00 + c] * (1 - tx) * (1 - ty) + o.rgba[i10 + c] * tx * (1 - ty) + o.rgba[i01 + c] * (1 - tx) * ty + o.rgba[i11 + c] * tx * ty;
            }
            out[di + 3] = 255;
          }
        }
        var before = codes.length;
        read(out, w, h, x0, y0, k);
        if (codes.length > before) {
          var nw = codes[codes.length - 1];
          for (var j = 0; j < before; j++) if (Math.abs(codes[j].cx - nw.cx) < nw.side / 3 && Math.abs(codes[j].cy - nw.cy) < nw.side / 3) { codes.pop(); break; }
        }
      });
      return { ok: true, codes: codes };
    }

    /* -- small words: the letters' real height inside each box the word
       reader found (words.js measureLine). Capitals stand about 0.71 of
       the type size; lowercase is judged by its x-height, about 0.52. -- */
    /* The word reader's boxes hug the letters, so only a small margin is
       searched (a dotted line just below the words must not count as
       letters). */
    function measureLine(img, box) {
      var W = img.w, H = img.h, d = img.data, bh = box.y1 - box.y0;
      var x0 = Math.max(0, Math.floor(box.x0)), x1 = Math.min(W - 1, Math.ceil(box.x1));
      var y0 = Math.max(0, Math.floor(box.y0 - bh * 0.12)), y1 = Math.min(H - 1, Math.ceil(box.y1 + bh * 0.12));
      if (x1 - x0 < 2 || y1 - y0 < 2) return null;
      var rim = [], x, y;
      for (x = x0; x <= x1; x++) rim.push((y0 * W + x) * 4, (y1 * W + x) * 4);
      for (y = y0; y <= y1; y++) rim.push((y * W + x0) * 4, (y * W + x1) * 4);
      var clearRim = rim.filter(function (i) { return d[i + 3] < 128; }).length, bg = null;
      if (clearRim < rim.length / 2) {
        var solid = rim.filter(function (i) { return d[i + 3] >= 128; });
        var mid = function (c) { var v = solid.map(function (i) { return d[i + c]; }).sort(function (p, q) { return p - q; }); return v[v.length >> 1]; };
        bg = [mid(0), mid(1), mid(2)];
      }
      function isInk(i) {
        if (bg) return d[i + 3] >= 128 && Math.max(Math.abs(d[i] - bg[0]), Math.abs(d[i + 1] - bg[1]), Math.abs(d[i + 2] - bg[2])) > 45;
        return d[i + 3] >= 192;
      }
      var rows = [];
      for (y = y0; y <= y1; y++) { var cnt = 0; for (x = x0; x <= x1; x++) if (isInk((y * W + x) * 4)) cnt++; rows.push(cnt); }
      var need = Math.max(1.5, (x1 - x0) * 0.006);
      function inked(r) { return r >= 0 && r < rows.length && rows[r] >= need; }
      var midRow = Math.round((box.y0 + box.y1) / 2) - y0, a = Math.max(0, Math.min(rows.length - 1, midRow));
      if (!inked(a)) {
        var found = -1;
        for (var k = 1; k < rows.length && found < 0; k++) { if (inked(a + k)) found = a + k; else if (inked(a - k)) found = a - k; }
        if (found < 0) return null;
        a = found;
      }
      var b = a;
      while (inked(a - 1) || inked(a - 2)) a -= inked(a - 1) ? 1 : 2;
      while (inked(b + 1) || inked(b + 2)) b += inked(b + 1) ? 1 : 2;
      var peak = a;
      for (var r = a; r <= b; r++) if (rows[r] > rows[peak]) peak = r;
      var ba = peak, bb = peak;
      while (ba - 1 >= a && rows[ba - 1] >= rows[peak] * 0.45) ba--;
      while (bb + 1 <= b && rows[bb + 1] >= rows[peak] * 0.45) bb++;
      return { extent: b - a + 1, band: bb - ba + 1 };
    }
    /* Each letter on its own: the ink inside the box split into separate
       shapes, then the typical letter height. A line or dots running
       through the words are separate shapes too, so they don't stretch
       the letters (the row count above can't tell them apart). Capitals:
       the usual height of the shapes. Lowercase: the shorter group (the
       x-height letters), when there is one. */
    function measureGlyphs(img, box, allCaps) {
      var W = img.w, H = img.h, d = img.data, bh = box.y1 - box.y0;
      var x0 = Math.max(0, Math.floor(box.x0 - bh * 0.06)), x1 = Math.min(W - 1, Math.ceil(box.x1 + bh * 0.06));
      var y0 = Math.max(0, Math.floor(box.y0 - bh * 0.08)), y1 = Math.min(H - 1, Math.ceil(box.y1 + bh * 0.08));
      var rw = x1 - x0 + 1, rh = y1 - y0 + 1;
      if (rw < 4 || rh < 4) return null;
      var rim = [], x, y;
      for (x = x0; x <= x1; x++) rim.push((y0 * W + x) * 4, (y1 * W + x) * 4);
      for (y = y0; y <= y1; y++) rim.push((y * W + x0) * 4, (y * W + x1) * 4);
      var solid = rim.filter(function (i) { return d[i + 3] >= 128; }), bg = null;
      if (solid.length > rim.length / 2) {
        var mid = function (c) { var v = solid.map(function (i) { return d[i + c]; }).sort(function (p, q) { return p - q; }); return v[v.length >> 1]; };
        bg = [mid(0), mid(1), mid(2)];
      }
      var ink = new Uint8Array(rw * rh);
      for (y = 0; y < rh; y++) {
        for (x = 0; x < rw; x++) {
          var i = ((y + y0) * W + x + x0) * 4;
          ink[y * rw + x] = bg
            ? (d[i + 3] >= 128 && Math.max(Math.abs(d[i] - bg[0]), Math.abs(d[i + 1] - bg[1]), Math.abs(d[i + 2] - bg[2])) > 45 ? 1 : 0)
            : (d[i + 3] >= 160 ? 1 : 0);
        }
      }
      var comp = components(ink, rw, rh), n = comp.count;
      if (n < 2 || n > 400) return null;
      var top = [], bot = [], left = [], right = [], area = [], k;
      for (k = 0; k <= n; k++) { top.push(rh); bot.push(-1); left.push(rw); right.push(-1); area.push(0); }
      for (y = 0; y < rh; y++) {
        for (x = 0; x < rw; x++) {
          var lb = comp.labels[y * rw + x];
          if (!lb) continue;
          area[lb]++;
          if (y < top[lb]) top[lb] = y; if (y > bot[lb]) bot[lb] = y;
          if (x < left[lb]) left[lb] = x; if (x > right[lb]) right[lb] = x;
        }
      }
      var hs = [];
      for (k = 1; k <= n; k++) {
        var hh = bot[k] - top[k] + 1, ww = right[k] - left[k] + 1;
        if (area[k] < 4 || hh < bh * 0.28) continue;
        if (ww > bh * 3) continue;
        hs.push(hh);
      }
      if (hs.length < 2) return null;
      hs.sort(function (p, q) { return p - q; });
      var med = hs[hs.length >> 1];
      if (allCaps) return { heightPx: med, em: 0.71, n: hs.length };
      var tall = hs[Math.min(hs.length - 1, Math.floor(hs.length * 0.9))];
      var shortOnes = hs.filter(function (v) { return v <= tall * 0.8; });
      if (shortOnes.length >= 2) return { heightPx: shortOnes[shortOnes.length >> 1], em: 0.52, n: hs.length };
      return { heightPx: med, em: 0.71, n: hs.length };
    }
    function measureLines(o) {
      var out = [];
      (o.lines || []).forEach(function (l) {
        var box = { x0: l.x0, y0: l.y0, x1: l.x1, y1: l.y1 }, boxH = box.y1 - box.y0;
        if (!(boxH > 0) || !(box.x1 > box.x0)) return;
        var g = measureGlyphs(o.img, box, l.allCaps), heightPx, em, how;
        if (g && g.heightPx >= boxH * 0.35 && g.heightPx <= boxH * 1.15) { heightPx = g.heightPx; em = g.em; how = 'letters'; }
        else {
          var m = measureLine(o.img, box);
          var sane = m && m.extent >= boxH * 0.6 && m.extent <= boxH * 1.3;
          if (sane && l.allCaps) { heightPx = m.extent; em = 0.71; how = 'rows'; }
          else if (sane && m.band >= 3) { heightPx = m.band; em = 0.52; how = 'rows'; }
          else { heightPx = boxH; em = l.allCaps ? 0.71 : 1.0; how = 'box'; }
        }
        out.push({ text: l.text, heightPx: heightPx, em: em, measured: how, x0: box.x0, y0: box.y0, x1: box.x1, y1: box.y1 });
      });
      return out;
    }

    return { prepare: prepare, cutField: cutField, enclosingCircle: enclosingCircle, details: details, qrFind: qrFind, jsqrScan: jsqrScan, measureLines: measureLines };
  }

  /* The worker (or the page itself, when workers aren't allowed). Inputs
     are copied, results come back transferred. */
  var Analysis = (function () {
    var worker = null, failed = false, seq = 0, pending = {}, local = null;
    function start() {
      if (worker || failed) return;
      try {
        var src = 'var A=(' + tspsAnalysis.toString() + ')();' +
          'function tr(v,list,seen){if(!v||typeof v!=="object")return;if(v.buffer instanceof ArrayBuffer&&v.byteLength!==undefined){if(seen.indexOf(v.buffer)<0){seen.push(v.buffer);list.push(v.buffer);}return;}for(var k in v){if(Object.prototype.hasOwnProperty.call(v,k))tr(v[k],list,seen);}}' +
          'self.onmessage=function(e){var m=e.data;try{var res=A[m.fn](m.args);var list=[];tr(res,list,[]);self.postMessage({id:m.id,ok:true,res:res},list);}catch(err){self.postMessage({id:m.id,ok:false,err:String(err&&err.message||err)});}};';
        var url = URL.createObjectURL(new Blob([src], { type: 'text/javascript' }));
        worker = new Worker(url);
        worker.onmessage = function (e) {
          var m = e.data, p = pending[m.id];
          if (!p) return;
          delete pending[m.id];
          if (m.ok) p.ok(m.res); else p.bad(new Error(m.err));
        };
        worker.onerror = function () {
          failed = true;
          try { worker.terminate(); } catch (e) { /* gone */ }
          worker = null;
          var list = pending;
          pending = {};
          Object.keys(list).forEach(function (id) { runLocal(list[id].fn, list[id].args).then(list[id].ok, list[id].bad); });
        };
      } catch (e) { failed = true; worker = null; }
    }
    function runLocal(fn, args) {
      if (!local) local = tspsAnalysis();
      var go = function () { return local[fn](args); };
      if (fn === 'jsqrScan' && typeof window.jsQR !== 'function') {
        return loadScript(LIBS.jsqr).then(go, go);
      }
      return new Promise(function (ok, bad) { setTimeout(function () { try { ok(go()); } catch (e) { bad(e); } }, 0); });
    }
    function call(fn, args) {
      start();
      if (!worker) return runLocal(fn, args);
      return new Promise(function (ok, bad) {
        var id = ++seq;
        pending[id] = { ok: ok, bad: bad, fn: fn, args: args };
        try { worker.postMessage({ id: id, fn: fn, args: args }); }
        catch (e) { delete pending[id]; runLocal(fn, args).then(ok, bad); }
      });
    }
    return { call: call };
  })();

  /* =========== prices =========== */
  function buildTiers(variants) {
    var tiers = {};
    SIZES.forEach(function (s) { tiers[s] = []; });
    (variants || []).forEach(function (v) {
      var toks = (String(v.title || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/g)) || [];
      var size = null, qty = null;
      toks.forEach(function (t) {
        var n = parseFloat(t);
        if (size === null) { for (var i = 0; i < SIZES.length; i++) if (parseFloat(SIZES[i]) === n) { size = SIZES[i]; return; } }
        if (qty === null && STD_QTYS.indexOf(n) >= 0) qty = n;
      });
      if (size === null || qty === null) return;
      var list = tiers[size];
      for (var j = 0; j < list.length; j++) if (list[j].qty === qty) return;
      list.push({ qty: qty, total: Number(v.price), id: v.id, available: v.available !== false });
    });
    SIZES.forEach(function (s) {
      tiers[s].sort(function (a, b) { return a.qty - b.qty; });
      var base = tiers[s][0] ? tiers[s][0].total / tiers[s][0].qty : 0;
      tiers[s].forEach(function (t, i) {
        var pct = base > 0 && i > 0 ? Math.round((1 - (t.total / t.qty) / base) * 100) : 0;
        t.save = pct > 0 ? pct : 0;
      });
    });
    return tiers;
  }

  /* =========== the texture look: Amber's real vinyl ===========
     Two seamless tiles made from her shop photos (Oct 17 2026: the average
     real bump, one tile = 17.2 x 26 mm of sticker; theme assets
     ts-pyo-texture-shadow.png and ts-pyo-texture-light.png, 12.5 px per mm).
     Per color channel, in plain sRGB: result = 1 - (1 - art * shadow) *
     (1 - light), that is multiply by the shadow tile, then screen with the
     light tile, the same recipe as the Sticker Studio. Light comes from the
     upper left: a gentle sweep across the sticker (about 4%) and the cut
     edge lit on that side (0.35 mm, about 22%), then a soft shadow and a
     tight contact shadow on the table. Tiny packed bumps, never big round
     balls. */
  var TEX = { mm: [17.2, 26], shadow: null, light: null, state: 'idle', waiters: [], settle: [], sized: {}, count: 0 };
  var TOWARD_LIGHT = [-0.6, -0.8];        /* x right, y down */
  /* her shadow pick (Oct 17 2026, "A little more shadow": 0.9 mm right,
     1.6 mm down, blur 1.8 mm, 38%, contact 0.2 mm, 26%) is darkened in
     linear light; a canvas shadow darkens plain screen color, so the same
     look here is 18% with a 1.7 mm blur, and 12% for the contact shadow
     (fitted to her picture, within half a shade) */
  var SOFT_SHADOW = { dx: 0.9, dy: 1.6, blur: 1.7, alpha: 0.18 };   /* mm */
  var CONTACT_SHADOW = { blur: 0.2, alpha: 0.12 };
  var RIM_MM = 0.35;
  /* how far the shadows reach past the cut (mm), so the picture leaves room */
  var REACH = { l: 3.6, r: 5.4, t: 2.9, b: 6.1 };
  /* a few work canvases, reused (phones are short on canvas memory) */
  var POOL = {};
  function poolCanvas(name, w, h) {
    var c = POOL[name] || (POOL[name] = document.createElement('canvas'));
    c.width = Math.max(1, Math.round(w));
    c.height = Math.max(1, Math.round(h));
    return c;
  }
  var blendOk = null;
  function canBlend(x) {
    if (blendOk !== null) return blendOk;
    x.save();
    blendOk = ['multiply', 'screen', 'color-dodge'].every(function (m) { x.globalCompositeOperation = m; return x.globalCompositeOperation === m; });
    x.restore();
    return blendOk;
  }
  function loadImage(src) {
    function once(cors) {
      return new Promise(function (ok, bad) {
        var img = new Image();
        if (cors) img.crossOrigin = 'anonymous';
        img.onload = function () { if (img.naturalWidth > 0) ok(img); else bad(new Error('empty picture')); };
        img.onerror = function () { bad(new Error('could not load ' + src)); };
        img.src = src;
      });
    }
    /* the theme's own files come from the shop's address; if a CDN won't
       share them, they still show (only page code would mind) */
    return once(true).catch(function () { return once(false); });
  }
  function loadTexture(spec, onReady) {
    if (TEX.state === 'ready') { onReady(); return; }
    if (TEX.state === 'failed') return;
    TEX.waiters.push(onReady);
    if (TEX.state === 'loading') return;
    if (!spec || !spec.shadow || !spec.light) { texDone('failed'); return; }
    TEX.state = 'loading';
    if (spec.tileMm && Number(spec.tileMm[0]) > 0 && Number(spec.tileMm[1]) > 0) TEX.mm = [Number(spec.tileMm[0]), Number(spec.tileMm[1])];
    Promise.all([loadImage(spec.shadow), loadImage(spec.light)]).then(function (imgs) {
      TEX.shadow = imgs[0]; TEX.light = imgs[1];
      texDone('ready');
    }).catch(function () { texDone('failed'); });
  }
  function texDone(state) {
    TEX.state = state;
    var w = state === 'ready' ? TEX.waiters : [], s = TEX.settle;
    TEX.waiters = []; TEX.settle = [];
    w.concat(s).forEach(function (fn) { try { fn(); } catch (e) { /* the next paint has it */ } });
  }
  /* resolves once the tiles are in (or gave up), or after ms */
  function textureSettled(ms) {
    if (TEX.state === 'ready' || TEX.state === 'failed' || TEX.state === 'idle') return Promise.resolve();
    return new Promise(function (ok) { TEX.settle.push(ok); setTimeout(ok, ms); });
  }
  /* one tile at this picture's scale, with no seam and no shimmer: a 3 x 3
     repeat brought down in halves, then to a whole number of pixels per
     tile, keeping the middle one (the studio does the same) */
  function tileAt(img, pxPerMm) {
    var tw = Math.max(4, Math.round(TEX.mm[0] * pxPerMm)), th = Math.max(4, Math.round(TEX.mm[1] * pxPerMm));
    var key = (img === TEX.shadow ? 's' : 'l') + tw + 'x' + th;
    if (TEX.sized[key]) return TEX.sized[key];
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    var cur = makeCanvas(w * 3, h * 3), b = cur.getContext('2d');
    for (var i = 0; i < 3; i++) for (var j = 0; j < 3; j++) b.drawImage(img, i * w, j * h);
    while (cur.width / 2 >= tw * 3 && cur.height / 2 >= th * 3) {
      var half = makeCanvas(cur.width / 2, cur.height / 2), hx = half.getContext('2d');
      hx.imageSmoothingEnabled = true; hx.imageSmoothingQuality = 'high';
      hx.drawImage(cur, 0, 0, cur.width, cur.height, 0, 0, half.width, half.height);
      cur.width = cur.height = 0;
      cur = half;
    }
    var t = makeCanvas(tw, th), c = t.getContext('2d');
    c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'high';
    c.drawImage(cur, 0, 0, cur.width, cur.height, -tw, -th, tw * 3, th * 3);
    cur.width = cur.height = 0;
    if (++TEX.count > 24) { TEX.sized = {}; TEX.count = 1; }
    TEX.sized[key] = t;
    return t;
  }
  /* the edge of the cut on one side: the sticker minus itself moved a hair */
  function edgeBand(scratch, cut, sx, sy, color) {
    var c = scratch.getContext('2d'), W = scratch.width, H = scratch.height;
    c.globalCompositeOperation = 'source-over';
    c.clearRect(0, 0, W, H);
    c.drawImage(cut, 0, 0);
    c.globalCompositeOperation = 'destination-out';
    c.drawImage(cut, sx, sy);
    c.globalCompositeOperation = 'source-in';
    c.fillStyle = color;
    c.fillRect(0, 0, W, H);
    return scratch;
  }
  /* the vinyl and the light on a flat sticker picture, in place. box: where
     the sticker sits, pxPerMm: the picture's scale. */
  function texturize(off, box, pxPerMm, withTiles) {
    var x = off.getContext('2d'), W = off.width, H = off.height;
    if (!canBlend(x)) return;
    var cut = poolCanvas('cut', W, H);
    cut.getContext('2d').drawImage(off, 0, 0);
    x.save();
    if (withTiles && TEX.state === 'ready') {
      x.globalCompositeOperation = 'multiply';
      x.fillStyle = x.createPattern(tileAt(TEX.shadow, pxPerMm), 'repeat');
      x.fillRect(0, 0, W, H);
      x.globalCompositeOperation = 'screen';
      x.fillStyle = x.createPattern(tileAt(TEX.light, pxPerMm), 'repeat');
      x.fillRect(0, 0, W, H);
    }
    /* the sweep: up to 4% more light toward the upper left, 4% less toward
       the lower right (color-dodge with 4/255 lifts by 1/(1 - 4/255)) */
    var cx = box.x + box.w / 2, cy = box.y + box.h / 2, reach = Math.max(1, Math.sqrt(box.w * box.w + box.h * box.h) / 2);
    var ax = cx + TOWARD_LIGHT[0] * reach, ay = cy + TOWARD_LIGHT[1] * reach, bx = cx - TOWARD_LIGHT[0] * reach, by = cy - TOWARD_LIGHT[1] * reach;
    var up = x.createLinearGradient(ax, ay, bx, by);
    up.addColorStop(0, 'rgb(4,4,4)'); up.addColorStop(0.5, 'rgb(0,0,0)'); up.addColorStop(1, 'rgb(0,0,0)');
    x.globalCompositeOperation = 'color-dodge';
    x.fillStyle = up;
    x.fillRect(0, 0, W, H);
    var down = x.createLinearGradient(ax, ay, bx, by);
    down.addColorStop(0, 'rgb(255,255,255)'); down.addColorStop(0.5, 'rgb(255,255,255)'); down.addColorStop(1, 'rgb(251,251,251)');
    x.globalCompositeOperation = 'multiply';
    x.fillStyle = down;
    x.fillRect(0, 0, W, H);
    /* the cut edge: lit on the upper left, a touch darker on the lower
       right, in two steps so it fades in from the edge */
    var r = RIM_MM * pxPerMm, scratch = poolCanvas('edge', W, H);
    [[1, 'rgb(10,10,10)', 'color-dodge'], [0.5, 'rgb(10,10,10)', 'color-dodge'], [-1, 'rgb(242,242,242)', 'multiply'], [-0.5, 'rgb(242,242,242)', 'multiply']].forEach(function (p) {
      edgeBand(scratch, cut, -TOWARD_LIGHT[0] * r * p[0], -TOWARD_LIGHT[1] * r * p[0], p[1]);
      x.globalCompositeOperation = p[2];
      x.drawImage(scratch, 0, 0);
    });
    /* back to the cut */
    x.globalCompositeOperation = 'destination-in';
    x.drawImage(cut, 0, 0);
    x.restore();
  }
  /* the shadows on the table. The sticker is drawn off the canvas so only
     its shadow lands; a canvas blur is two standard deviations. */
  function dropShadows(ctx, cut, pxPerMm) {
    var away = cut.width + cut.height + 64;
    ctx.save();
    ctx.shadowColor = 'rgba(0, 0, 0, ' + SOFT_SHADOW.alpha + ')';
    ctx.shadowBlur = 2 * SOFT_SHADOW.blur * pxPerMm;
    ctx.shadowOffsetX = away + SOFT_SHADOW.dx * pxPerMm;
    ctx.shadowOffsetY = SOFT_SHADOW.dy * pxPerMm;
    ctx.drawImage(cut, -away, 0);
    ctx.shadowColor = 'rgba(0, 0, 0, ' + CONTACT_SHADOW.alpha + ')';
    ctx.shadowBlur = 2 * CONTACT_SHADOW.blur * pxPerMm;
    ctx.shadowOffsetX = away;
    ctx.shadowOffsetY = 0;
    ctx.drawImage(cut, -away, 0);
    ctx.restore();
  }

  /* =========== drawing a sticker =========== */
  function fieldCanvas(f) {
    if (f._canvas) return f._canvas;
    var c = makeCanvas(f.W, f.H), x = c.getContext('2d'), img = x.createImageData(f.W, f.H), d = img.data;
    for (var p = 0, i = 0; p < f.field.length; p++, i += 4) {
      var v = f.field[p], a = v <= 0.38 ? 0 : v >= 0.62 ? 1 : (v - 0.38) / 0.24;
      d[i] = 255; d[i + 1] = 255; d[i + 2] = 255; d[i + 3] = Math.round(a * 255);
    }
    x.putImageData(img, 0, 0);
    f._canvas = c;
    return c;
  }
  function roundRectPath(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y); ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r); ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h); ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r); ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
  }
  /* base (the white vinyl, or their own background color), then the art
     painted only where the sticker is */
  function drawSticker(ctx, L, ver, k, ox, oy) {
    ctx.save();
    if (L.kind === 'field') {
      var f = L.field, fc = fieldCanvas(f), s = k / f.R;
      ctx.drawImage(fc, ox - f.cut.x0 * s, oy - f.cut.y0 * s, f.W * s, f.H * s);
    } else {
      ctx.fillStyle = L.bg;
      if (L.kind === 'circle') { ctx.beginPath(); ctx.arc(ox + L.wIn * k / 2, oy + L.hIn * k / 2, L.wIn * k / 2, 0, Math.PI * 2); ctx.fill(); }
      else { roundRectPath(ctx, ox, oy, L.wIn * k, L.hIn * k, L.radius * k); ctx.fill(); }
    }
    ctx.globalCompositeOperation = 'source-atop';
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(ver.canvas, ox + L.artBox.x * k, oy + L.artBox.y * k, L.artBox.w * k, L.artBox.h * k);
    ctx.restore();
  }
  /* a look for the screen: the sticker on her real vinyl, lit from the
     upper left, its shadow on the table, and the numbered marks on the
     picked look. The tiles span their real 17.2 x 26 mm at the size the
     sticker is drawn. */
  function paintLook(canvas, L, ver, opts) {
    opts = opts || {};
    var W = canvas.width, H = canvas.height;
    if (W < 4 || H < 4) return null;
    var fill = opts.fill || 0.84;
    /* as big as the fill allows, leaving room for the shadow */
    var k = Math.min(Math.min(W, H) * fill / Math.max(L.wIn, L.hIn), W / (L.wIn + (REACH.l + REACH.r) / 25.4), H / (L.hIn + (REACH.t + REACH.b) / 25.4));
    var pm = k / 25.4;
    var ox = (W - L.wIn * k - (REACH.l + REACH.r) * pm) / 2 + REACH.l * pm;
    var oy = (H - L.hIn * k - (REACH.t + REACH.b) * pm) / 2 + REACH.t * pm;
    var off = poolCanvas('look', W, H);
    drawSticker(off.getContext('2d'), L, ver, k, ox, oy);
    texturize(off, { x: ox, y: oy, w: L.wIn * k, h: L.hIn * k }, pm, opts.texture !== false);
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, W, H);
    dropShadows(ctx, off, pm);
    ctx.drawImage(off, 0, 0);
    if (opts.marks && opts.marks.length) drawMarks(ctx, opts.marks, L, ver, k, ox, oy, W);
    return { k: k, ox: ox, oy: oy };
  }
  function drawMarks(ctx, marks, L, ver, k, ox, oy, W) {
    var u = Math.max(1, W / 360);
    marks.forEach(function (mk) {
      var sx = L.artBox.w * k / ver.w, sy = L.artBox.h * k / ver.h;
      var x0 = ox + L.artBox.x * k + mk.x0 * sx, x1 = ox + L.artBox.x * k + mk.x1 * sx;
      var y0 = oy + L.artBox.y * k + mk.y0 * sy, y1 = oy + L.artBox.y * k + mk.y1 * sy;
      var cx = (x0 + x1) / 2, cy = (y0 + y1) / 2;
      var rx = Math.max(10 * u, (x1 - x0) / 2 * 1.18 + 5 * u), ry = Math.max(8 * u, (y1 - y0) / 2 * 1.35 + 5 * u);
      ctx.save();
      ctx.strokeStyle = '#C4502F';
      ctx.lineWidth = 2.2 * u;
      if (ctx.setLineDash) ctx.setLineDash([5 * u, 3.5 * u]);
      ctx.beginPath();
      ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
      ctx.stroke();
      if (ctx.setLineDash) ctx.setLineDash([]);
      var br = 10 * u, bx = Math.min(W - br - 2, cx + rx * 0.82), by = Math.max(br + 2, cy - ry * 0.82);
      ctx.fillStyle = '#C4502F';
      ctx.beginPath(); ctx.arc(bx, by, br, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#FFFFFF';
      ctx.font = '700 ' + Math.round(12 * u) + 'px Inter, system-ui, sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText(String(mk.n), bx, by + 0.5 * u);
      ctx.restore();
    });
  }

  /* =========== opening their file =========== */
  function canvasFromImage(img, natW, natH, maxSide) {
    var s = Math.min(1, maxSide / Math.max(natW, natH));
    var c = makeCanvas(natW * s, natH * s), x = c.getContext('2d');
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    x.drawImage(img, 0, 0, c.width, c.height);
    return c;
  }
  function loadImg(url) {
    return new Promise(function (ok, bad) {
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { ok(im); };
      im.onerror = function () { bad(new Error('image would not open')); };
      im.src = url;
    });
  }
  function decodeRaster(file) {
    var url = URL.createObjectURL(file);
    return loadImg(url).then(function (im) {
      var w = im.naturalWidth, h = im.naturalHeight;
      if (!w || !h) throw new Error('empty image');
      var c = canvasFromImage(im, w, h, DECODE_MAX);
      URL.revokeObjectURL(url);
      return { canvas: c, natW: w, natH: h, vector: false, kind: 'raster' };
    }, function (e) { URL.revokeObjectURL(url); throw e; });
  }
  function decodeSvg(file) {
    return file.text().then(function (txt) {
      var doc = new DOMParser().parseFromString(txt, 'image/svg+xml');
      var svg = doc.documentElement;
      if (!svg || svg.nodeName.toLowerCase() !== 'svg') throw new Error('not an svg');
      var vb = (svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(parseFloat);
      var w = parseFloat(svg.getAttribute('width')), h = parseFloat(svg.getAttribute('height'));
      if (/%/.test(svg.getAttribute('width') || '')) w = NaN;
      if (/%/.test(svg.getAttribute('height') || '')) h = NaN;
      var vx = 0, vy = 0, vw, vh;
      if (vb.length === 4 && vb[2] > 0 && vb[3] > 0) { vx = vb[0]; vy = vb[1]; vw = vb[2]; vh = vb[3]; }
      else if (w > 0 && h > 0) { vw = w; vh = h; }
      else { vw = 1000; vh = 1000; }
      /* drawn at about 2400 px across: the whole drawing first, then
         zoomed to the art when it sits small in a big frame */
      function raster(x, y, rw, rh) {
        var s = 2400 / Math.max(rw, rh);
        svg.setAttribute('viewBox', x + ' ' + y + ' ' + rw + ' ' + rh);
        svg.setAttribute('width', String(Math.max(1, Math.round(rw * s))));
        svg.setAttribute('height', String(Math.max(1, Math.round(rh * s))));
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        var url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' }));
        return loadImg(url).then(function (im) {
          var c = makeCanvas(rw * s, rh * s);
          c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
          URL.revokeObjectURL(url);
          return { canvas: c, s: s };
        }, function (e) { URL.revokeObjectURL(url); throw e; });
      }
      return raster(vx, vy, vw, vh).then(function (r1) {
        var b = inkBox(r1.canvas);
        if (!b || Math.max(b.w, b.h) > 0.75 * Math.max(r1.canvas.width, r1.canvas.height)) return r1.canvas;
        var m = 0.02 * Math.max(b.w, b.h);
        return raster(vx + (b.x - m) / r1.s, vy + (b.y - m) / r1.s, (b.w + 2 * m) / r1.s, (b.h + 2 * m) / r1.s).then(function (r2) { return r2.canvas; });
      }).then(function (c) {
        return { canvas: c, natW: c.width, natH: c.height, vector: true, kind: 'svg' };
      });
    });
  }
  var pdfReady = null;
  function getPdfJs() {
    if (pdfReady) return pdfReady;
    pdfReady = loadScript(LIBS.pdf).then(function () {
      var lib = window.pdfjsLib;
      if (!lib) throw new Error('pdf reader missing');
      try {
        var wurl = URL.createObjectURL(new Blob(['importScripts(' + JSON.stringify(LIBS.pdfWorker) + ');'], { type: 'text/javascript' }));
        lib.GlobalWorkerOptions.workerPort = new Worker(wurl);
      } catch (e) { lib.GlobalWorkerOptions.workerSrc = LIBS.pdfWorker; }
      return lib;
    });
    pdfReady.catch(function () { pdfReady = null; });
    return pdfReady;
  }
  /* PDFium, the PDF reader the portal uses. pdf.js has its own math for
     CMYK (100% magenta comes out #FB3199, Illustrator shows #EC008C), and
     the picture drawn here is the one that prints. So pdf.js finds the art
     and reads the words, then PDFium draws the picture the way Illustrator
     shows it. It runs in its own worker: a heavy file can't freeze the page
     and can be stopped. A string, because import() would stop this whole
     script from loading on a browser too old to know it. */
  var PDFIUM_WORKER = [
    'var ready = null;',
    'function lib(url) {',
    '  return ready || (ready = import(url).then(function (m) { return m.PDFiumLibrary.init({ disableCDNWarning: true }); }));',
    '}',
    'function draw(L, j) {',
    '  return j.file.arrayBuffer().then(function (b) { return L.loadDocument(new Uint8Array(b)); }).then(function (doc) {',
    '    var m = L.module, page = doc.getPage(0), ptr = 0, bmp = 0, size = j.w * j.h * 4;',
    '    try {',
    '      var o = page.getOriginalSize();',
    '      if (Math.abs(o.originalWidth * j.pageH - o.originalHeight * j.pageW) > 0.01 * j.pageW * j.pageH) throw new Error("page shape differs");',
    '      ptr = m.wasmExports.malloc(size);',
    '      if (!ptr) throw new Error("no memory");',
    '      bmp = m._FPDFBitmap_CreateEx(j.w, j.h, 4, ptr, j.w * 4);',
    '      m._FPDFBitmap_FillRect(bmp, 0, 0, j.w, j.h, 0);',
    /* the whole page at full size, moved so the art lands on this small
       bitmap; 0x13 = annotations + LCD text + RGBA, the portal's own flags */
    '      m._FPDF_RenderPageBitmap(bmp, page.pageIdx, -j.x, -j.y, j.fullW, j.fullH, 0, 0x13);',
    '      return m.HEAPU8.slice(ptr, ptr + size);',
    '    } finally {',
    '      if (bmp) m._FPDFBitmap_Destroy(bmp);',
    '      if (ptr) m.wasmExports.free(ptr);',
    '      m._FPDF_ClosePage(page.pageIdx);',
    '      doc.destroy();',
    '    }',
    '  });',
    '}',
    'self.onmessage = function (e) {',
    '  var d = e.data;',
    '  lib(d.url).then(function (L) { return d.job ? draw(L, d.job) : null; }).then(function (px) {',
    '    if (px) self.postMessage({ id: d.id, ok: true, px: px }, [px.buffer]);',
    '  }).catch(function (err) { self.postMessage({ id: d.id, ok: false, err: String(err && err.message || err) }); });',
    '};'
  ].join('\n');
  var pdfium = (function () {
    var worker = null, seq = 0, waiting = {};
    function stop(why) {
      if (worker) { try { worker.terminate(); } catch (e) { /* gone */ } }
      worker = null;
      var list = waiting;
      waiting = {};
      Object.keys(list).forEach(function (id) { list[id].bad(new Error(why)); });
    }
    /* loads alongside pdf.js, so it's ready by the time the art is found */
    function start() {
      if (worker) return;
      try {
        worker = new Worker(URL.createObjectURL(new Blob([PDFIUM_WORKER], { type: 'text/javascript' })), { type: 'module' });
        worker.onmessage = function (e) {
          var m = e.data, w = waiting[m.id];
          if (m.ok) { if (w) { delete waiting[m.id]; w.ok(m.px); } return; }
          /* can't load, or can't read this file: a fresh start for the next one */
          if (w) { delete waiting[m.id]; w.bad(new Error(m.err)); }
          stop(m.err);
        };
        worker.onerror = function () { stop('pdfium worker failed'); };
        worker.postMessage({ url: LIBS.pdfium });
      } catch (e) { worker = null; }
    }
    function draw(job) {
      return new Promise(function (ok, bad) {
        start();
        if (!worker) { bad(new Error('no pdfium worker')); return; }
        var id = ++seq, timer = setTimeout(function () { stop('pdfium too slow'); }, PDFIUM_MS);
        waiting[id] = {
          ok: function (px) { clearTimeout(timer); ok(px); },
          bad: function (e) { clearTimeout(timer); bad(e); }
        };
        try { worker.postMessage({ url: LIBS.pdfium, id: id, job: job }); }
        catch (e) { waiting[id].bad(e); delete waiting[id]; }
      });
    }
    return { start: start, draw: draw };
  })();
  /* where the drawing is on a picture (alpha above 8), or null */
  function inkBox(c) {
    var W = c.width, H = c.height, d = c.getContext('2d').getImageData(0, 0, W, H).data;
    var x0 = W, y0 = H, x1 = -1, y1 = -1;
    for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) if (d[(y * W + x) * 4 + 3] > 8) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; y1 = y; }
    return x1 < 0 ? null : { x: x0, y: y0, w: x1 - x0 + 1, h: y1 - y0 + 1 };
  }
  /* A logo often sits small in the middle of a letter-size page, so the
     page is drawn twice: small to find the art, then zoomed to the art
     itself (about 2400 px across), so tiny words stay crisp. */
  function decodePdf(file) {
    pdfium.start();
    return Promise.all([file.arrayBuffer(), getPdfJs()]).then(function (r) {
      var buf = r[0], lib = r[1];
      return lib.getDocument({ data: new Uint8Array(buf), isEvalSupported: false }).promise.then(function (doc) {
        return doc.getPage(1).then(function (page) {
          var vp1 = page.getViewport({ scale: 1 });
          var s1 = Math.min(4, 1000 / Math.max(vp1.width, vp1.height));
          var c1 = makeCanvas(vp1.width * s1, vp1.height * s1);
          return page.render({ canvasContext: c1.getContext('2d'), viewport: page.getViewport({ scale: s1 }), background: 'rgba(0,0,0,0)' }).promise.then(function () {
            var b = inkBox(c1), bx = 0, by = 0, bw = vp1.width, bh = vp1.height;
            if (b) {
              var m = Math.max(2, 0.02 * Math.max(b.w, b.h));
              bx = Math.max(0, (b.x - m) / s1); by = Math.max(0, (b.y - m) / s1);
              bw = Math.min(vp1.width - bx, (b.w + 2 * m) / s1); bh = Math.min(vp1.height - by, (b.h + 2 * m) / s1);
            }
            return { bx: bx, by: by, bw: bw, bh: bh };
          });
        }).then(function (box) {
          return doc.getPage(1).then(function (page) {
            var vp1 = page.getViewport({ scale: 1 });
            var scale = Math.min(24, 2400 / Math.max(box.bw, box.bh));
            var vp = page.getViewport({ scale: scale });
            var c = makeCanvas(box.bw * scale, box.bh * scale);
            var ctx = c.getContext('2d');
            return { page: page, vp1: vp1, scale: scale, vp: vp, c: c, ctx: ctx, box: box };
          });
        }).then(function (P) {
          var page = P.page, vp1 = P.vp1, scale = P.scale, c = P.c, reader = '';
          return paintPdf(file, P).then(function (who) {
            reader = who;
            return Promise.all([
              page.getTextContent().then(function (t) { return t.items.map(function (i) { return i.str; }).join(' '); }).catch(function () { return ''; }),
              pdfImagePpi(page, lib, vp1).catch(function () { return null; })
            ]);
          }).then(function (extra) {
            if (/saved without pdf content|without pdf content/i.test(extra[0] || '')) {
              var e = new Error('ai without pdf'); e.noPreview = true; throw e;
            }
            return { canvas: c, natW: c.width, natH: c.height, vector: true, kind: 'pdf', pages: doc.numPages, pdfScale: scale, pdfImages: extra[1], pdfReader: reader };
          });
        });
      });
    });
  }
  /* The final picture: PDFium's, or pdf.js's as it always was if PDFium
     can't. Says which one drew it. */
  function paintPdf(file, P) {
    var c = P.c, ctx = P.ctx, scale = P.scale, box = P.box, vp1 = P.vp1;
    return pdfium.draw({
      file: file, pageW: vp1.width, pageH: vp1.height,
      x: Math.round(box.bx * scale), y: Math.round(box.by * scale), w: c.width, h: c.height,
      fullW: Math.round(vp1.width * scale), fullH: Math.round(vp1.height * scale)
    }).then(function (px) {
      ctx.putImageData(new ImageData(new Uint8ClampedArray(px), c.width, c.height), 0, 0);
      /* pdf.js found art right up to these edges: if this picture stops
         well short of them, PDFium missed some of it */
      var b = inkBox(c);
      if (!b || b.w < 0.8 * c.width || b.h < 0.8 * c.height) throw new Error('pdfium missed some art');
      return 'PDFium';
    }).catch(function () {
      ctx.clearRect(0, 0, c.width, c.height);
      return P.page.render({ canvasContext: ctx, viewport: P.vp, transform: [1, 0, 0, 1, -box.bx * scale, -box.by * scale], background: 'rgba(0,0,0,0)' }).promise.then(function () { return 'pdf.js'; });
    });
  }
  /* Pictures inside a PDF: each one's own pixels and where it's drawn (in
     points), so a PDF that's really a small JPG gets the sharpness check
     too. */
  function pdfImagePpi(page, lib, vp1) {
    return page.getOperatorList().then(function (ol) {
      var OPS = lib.OPS, stack = [], ctm = [1, 0, 0, 1, 0, 0], out = [];
      function mul(m, n) { return [m[0] * n[0] + m[2] * n[1], m[1] * n[0] + m[3] * n[1], m[0] * n[2] + m[2] * n[3], m[1] * n[2] + m[3] * n[3], m[0] * n[4] + m[2] * n[5] + m[4], m[1] * n[4] + m[3] * n[5] + m[5]]; }
      for (var i = 0; i < ol.fnArray.length; i++) {
        var fn = ol.fnArray[i], args = ol.argsArray[i];
        if (fn === OPS.save) stack.push(ctm.slice());
        else if (fn === OPS.restore) ctm = stack.pop() || [1, 0, 0, 1, 0, 0];
        else if (fn === OPS.transform) ctm = mul(ctm, args);
        else if (fn === OPS.paintImageXObject || fn === OPS.paintInlineImageXObject || fn === OPS.paintJpegXObject) {
          var w = 0, h = 0;
          if (args && typeof args[1] === 'number') { w = args[1]; h = args[2]; }
          else if (args && args[0] && args[0].width) { w = args[0].width; h = args[0].height; }
          var dw = Math.sqrt(ctm[0] * ctm[0] + ctm[1] * ctm[1]), dh = Math.sqrt(ctm[2] * ctm[2] + ctm[3] * ctm[3]);
          if (w && h && dw > 1 && dh > 1) out.push({ w: w, h: h, dwPt: dw, dhPt: dh, x: ctm[4], y: ctm[5] });
        }
      }
      return { images: out, pageW: vp1.width, pageH: vp1.height };
    });
  }
  function decodeFile(file) {
    var ext = extOf(file.name), type = file.type || '';
    if (ext === 'pdf' || ext === 'ai' || type === 'application/pdf') return decodePdf(file);
    if (ext === 'svg' || type === 'image/svg+xml') return decodeSvg(file);
    return decodeRaster(file).catch(function (e) {
      if (NO_PREVIEW.indexOf(ext) >= 0) e.noPreview = true;
      throw e;
    });
  }

  /* =========== Cloudinary =========== */
  function cloudUpload(cfg, blob, fileName, folder, onProgress) {
    return new Promise(function (resolve, reject) {
      function attempt(kind) {
        var fd = new FormData();
        fd.append('file', blob, fileName);
        fd.append('upload_preset', cfg.cloud.preset);
        fd.append('folder', folder);
        var xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + encodeURIComponent(cfg.cloud.name) + '/' + kind + '/upload', true);
        if (xhr.upload && onProgress) xhr.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(e.loaded, e.total); };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            try { var r = JSON.parse(xhr.responseText); if (r && r.secure_url) { resolve(r.secure_url); return; } } catch (e) { /* below */ }
            reject(new Error('Cloudinary answered oddly'));
            return;
          }
          if (kind === 'image' && xhr.status >= 400 && xhr.status < 500 && !/^image\/(png|jpe?g|webp|gif|svg)/i.test(blob.type || '')) { attempt('raw'); return; }
          reject(new Error('Cloudinary ' + xhr.status));
        };
        xhr.onerror = function () { reject(new Error('network')); };
        xhr.send(fd);
      }
      attempt('image');
    });
  }

  /* =========== the word reader (Tesseract, loaded on the first file) =========== */
  var tessReady = null;
  function getTesseract() {
    if (tessReady) return tessReady;
    tessReady = loadScript(LIBS.tess).then(function () {
      if (!window.Tesseract || !window.Tesseract.createWorker) throw new Error('word reader missing');
      return window.Tesseract.createWorker('eng', 1, {
        workerPath: LIBS.tessWorker, corePath: LIBS.tessCore, langPath: LIBS.tessLang,
        workerBlobURL: true, logger: function () {}, errorHandler: function () {}
      });
    }).then(function (w) {
      return w.setParameters({ tessedit_pageseg_mode: '11', preserve_interword_spaces: '1' }).then(function () { return w; });
    });
    tessReady.catch(function () { tessReady = null; });
    return tessReady;
  }
  var tessQueue = Promise.resolve();
  function readWords(canvas) {
    var job = tessQueue.then(function () {
      return getTesseract().then(function (w) { return w.recognize(canvas, {}, { blocks: true, text: false }); });
    });
    tessQueue = job.catch(function () {});
    return job.then(function (res) {
      var data = (res && res.data) || {}, lines = [];
      if (data.lines && data.lines.length) lines = data.lines;
      else (data.blocks || []).forEach(function (b) { (b.paragraphs || []).forEach(function (p) { (p.lines || []).forEach(function (l) { lines.push(l); }); }); });
      var out = [];
      /* Only real words count: the reader also "sees" letters in dotted
         lines and patterns (a row of dashes reads as "11"), so short or
         shaky bits need more confidence, digits need a real number's
         length (a phone number, a year), and a repeated mark is never a
         word. */
      function realWord(w) {
        var t = String(w.text || '').trim(), alnum = t.replace(/[^A-Za-z0-9]/g, '');
        if (!alnum.length || alnum.length < t.length * 0.5) return false;
        if (/^(.)\1+$/i.test(alnum) && alnum.length < 4) return false;
        if (/^[0-9]+$/.test(alnum) && alnum.length < 3) return w.confidence >= 85;
        if (alnum.length <= 2) return w.confidence >= 80;
        if (alnum.length === 3) return w.confidence >= 70;
        return w.confidence >= 58;
      }
      lines.forEach(function (l) {
        var words = (l.words || []).filter(realWord);
        if (!words.length) return;
        var text = words.map(function (w) { return String(w.text).trim(); }).join(' ').replace(/^[^A-Za-z0-9]+|[^A-Za-z0-9.!?)%]+$/g, '');
        var alnum = text.replace(/[^A-Za-z0-9]/g, '');
        var conf = words.reduce(function (s, w) { return s + w.confidence; }, 0) / words.length;
        if (alnum.length < 3 || conf < 65) return;
        if (/^[0-9]+$/.test(alnum) && alnum.length < 4) return;
        if (/^(.)\1+$/i.test(alnum)) return;
        var b = { x0: Infinity, y0: Infinity, x1: -Infinity, y1: -Infinity };
        words.forEach(function (w) { b.x0 = Math.min(b.x0, w.bbox.x0); b.y0 = Math.min(b.y0, w.bbox.y0); b.x1 = Math.max(b.x1, w.bbox.x1); b.y1 = Math.max(b.y1, w.bbox.y1); });
        out.push({ text: text, conf: conf, x0: b.x0, y0: b.y0, x1: b.x1, y1: b.y1, allCaps: !/[a-z]/.test(text) });
      });
      return out;
    });
  }

  /* =========== dates (the portal's Production dials) =========== */
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function utahToday() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Denver', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      var d = new Date(parseInt(p.year, 10), parseInt(p.month, 10) - 1, parseInt(p.day, 10));
      if (!isNaN(d.getTime())) return d;
    } catch (e) { /* older browser */ }
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }
  function dayWord(d, today) {
    var diff = Math.round((d - today) / 86400000);
    if (diff <= 0) return 'today';
    if (diff === 1) return 'tomorrow';
    if (diff < 7) return d.toLocaleDateString('en-US', { weekday: 'long' });
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  /* =========== the page =========== */
  function initRoot(root) {
    if (root.__tspsReady) return;
    root.__tspsReady = true;
    var cfg;
    try { cfg = JSON.parse(qs(root, '[data-tsps-config]').textContent); } catch (e) { return; }
    var cut = cfg.cutoffs || { wordsPt: 10, linePt: 1, qrIn: 0.6, sharpPpi: 150 };
    cut.wordsPt = Number(cut.wordsPt) || 10; cut.linePt = Number(cut.linePt) || 1; cut.qrIn = Number(cut.qrIn) || 0.6; cut.sharpPpi = Number(cut.sharpPpi) || 150;
    var tiers = buildTiers(cfg.variants);
    var money = (function () {
      var f = null;
      try { f = new Intl.NumberFormat('en-US', { style: 'currency', currency: cfg.currency || 'USD' }); } catch (e) { f = null; }
      return function (n) { return f ? f.format(n) : '$' + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    })();

    var E = {
      intro: qs(root, '[data-tsps-intro]'), when: qs(root, '[data-tsps-when]'),
      before: qs(root, '[data-tsps-before]'), after: qs(root, '[data-tsps-after]'),
      stage: qs(root, '[data-tsps-stage]'), example: qs(root, '[data-tsps-example]'),
      photo: qs(root, '[data-tsps-photo]'), video: qs(root, '[data-tsps-video]'),
      stageArt: qs(root, '[data-tsps-stageart]'), stageAdd: qs(root, '[data-tsps-stageadd]'),
      thumbs: qsa(root, '[data-tsps-thumb]'),
      filename: qs(root, '[data-tsps-filename]'), lookbox: qs(root, '[data-tsps-lookbox]'),
      looks: qsa(root, '[data-tsps-look]'), checked: qs(root, '[data-tsps-checked]'),
      big: qs(root, '[data-tsps-big]'), yours: qs(root, '[data-tsps-yours]'), lookcap: qs(root, '[data-tsps-lookcap]'),
      checks: qs(root, '[data-tsps-checks]'), good: qs(root, '[data-tsps-good]'), sum: qs(root, '[data-tsps-sum]'), otters: qsa(root, '[data-tsps-otter]'),
      sizes: qsa(root, '[data-tsps-size]'), dims: qs(root, '[data-tsps-dims]'),
      qtys: qs(root, '[data-tsps-qtys]'), qtyrow: qs(root, '[data-tsps-qtyrow]'),
      artpick: qs(root, '[data-tsps-artpick]'), filerow: qs(root, '[data-tsps-filerow]'), artlabel: qs(root, '[data-tsps-artlabel]'),
      backs: qs(root, '[data-tsps-backs]'), backsSave: qs(root, '[data-tsps-backs-save]'),
      what: qs(root, '[data-tsps-what]'), total: qs(root, '[data-tsps-total]'), currency: qs(root, '[data-tsps-currency]'),
      rightsbox: qs(root, '[data-tsps-rightsbox]'), rights: qs(root, '[data-tsps-rights]'), rightswarn: qs(root, '[data-tsps-rightswarn]'),
      cart: qs(root, '[data-tsps-cart]'), cartmsg: qs(root, '[data-tsps-cartmsg]'),
      proofline: qs(root, '[data-tsps-proofline]'), date: qs(root, '[data-tsps-date]'), datetext: qs(root, '[data-tsps-datetext]'),
      mail: qs(root, '[data-tsps-mail]'), fast: qs(root, '[data-tsps-fast]'),
      file: qs(root, '[data-tsps-file]')
    };

    var params = new URLSearchParams(location.search);
    var S = {
      size: SIZES.indexOf(String(cfg.sizeDefault)) >= 0 ? String(cfg.sizeDefault) : '3',
      qty: parseInt(cfg.qtyDefault, 10) || 250,
      backs: !!(cfg.backsDefault && cfg.coupon),
      look: 'die_cut',
      exampleLook: 'die_cut',
      file: null,      /* what they picked: name, original upload */
      art: null,       /* their art, opened and cleaned */
      noFileYet: false,
      answers: {},
      qtyOpen: false,
      qtyMore: false,
      turn: 0,
      adding: false,
      lead: null
    };
    /* ?size=3&qty=250 (the purchasing email link), or Shopify's ?variant= */
    (function fromUrl() {
      var vs = params.get('variant');
      if (vs) {
        SIZES.forEach(function (s) { tiers[s].forEach(function (t) { if (String(t.id) === vs) { S.size = s; S.qty = t.qty; } }); });
      }
      var ps = params.get('size');
      if (ps) { var n = parseFloat(ps); SIZES.forEach(function (s) { if (parseFloat(s) === n) S.size = s; }); }
      var pq = parseInt(params.get('qty'), 10);
      if (pq && STD_QTYS.indexOf(pq) >= 0) S.qty = pq;
    })();
    if (!tierFor(S.size, S.qty)) { var list0 = tiers[S.size] || []; if (list0.length) S.qty = (list0[2] || list0[0]).qty; }
    if (E.backs) E.backs.checked = S.backs;

    function tierFor(size, qty) {
      var list = tiers[size] || [];
      for (var i = 0; i < list.length; i++) if (list[i].qty === qty) return list[i];
      return null;
    }

    /* -- buy box -- */
    function renderSizes() {
      E.sizes.forEach(function (b) {
        var on = b.getAttribute('data-tsps-size') === S.size;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      var L = S.art ? layoutNow(S.look, S.size) : null;
      if (L && E.dims) {
        E.dims.hidden = false;
        E.dims.textContent = 'Your ' + inch(S.size) + ' ' + LOOK_WORDS[S.look] + ' is ' + inch(round1(L.wIn)) + ' x ' + inch(round1(L.hIn)) + '.';
      } else if (E.dims) E.dims.hidden = true;
    }
    function qtyLabel(t, on) {
      return '<span>' + (on ? '<span class="tsps-qty__dot" aria-hidden="true"></span>' : '') + fmtQty(t.qty) + '</span>' +
        '<span>' + money(t.total) + (t.save ? ' <span class="tsps-qty__save">save ' + t.save + '%</span>' : '') + '</span>';
    }
    function renderQty() {
      var list = tiers[S.size] || [];
      var collapsed = !!(S.file || S.noFileYet) && !S.qtyOpen;
      var t = tierFor(S.size, S.qty);
      if (E.qtyrow) {
        E.qtyrow.hidden = !collapsed;
        E.qtyrow.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        if (t) E.qtyrow.innerHTML = '<span><strong>' + fmtQty(t.qty) + '</strong> stickers' + (t.save ? ' &middot; <span class="tsps-qty__save">save ' + t.save + '%</span>' : '') + '</span><span>' + money(t.total) + ' &#9662;</span>';
      }
      E.qtys.hidden = collapsed;
      if (collapsed) return;
      var shown = S.qtyMore ? list : list.filter(function (x) { return SHOW_QTYS.indexOf(x.qty) >= 0 || x.qty === S.qty; });
      var html = shown.map(function (x) {
        var on = x.qty === S.qty;
        return '<button type="button" role="radio" class="tsps-qty' + (on ? ' is-on' : '') + '" aria-checked="' + on + '" tabindex="' + (on ? 0 : -1) + '" data-tsps-qty="' + x.qty + '">' + qtyLabel(x, on) + '</button>';
      }).join('');
      if (!S.qtyMore && list.length > shown.length) {
        html += '<button type="button" class="tsps-qty tsps-qty--more" data-tsps-qtymore>More amounts, up to ' + fmtQty(list[list.length - 1].qty) + '</button>';
      }
      if (!list.length) html = '<div class="tsps-qty tsps-qty--static">Sizes and amounts are loading. Refresh the page if this stays.</div>';
      E.qtys.innerHTML = html;
    }
    function priceNow() {
      var t = tierFor(S.size, S.qty);
      if (!t) return null;
      var final = S.backs ? round2(t.total * 0.9) : t.total;
      return { tier: t, std: t.total, final: final, saved: round2(t.total - final) };
    }
    function renderTotal() {
      var p = priceNow();
      var shapeWord = (S.file && S.art) ? ' ' + LOOK_WORDS[S.look] : '';
      E.what.textContent = fmtQty(S.qty) + ' stickers \u00b7 ' + inch(S.size) + shapeWord;
      E.total.textContent = p ? money(p.final) : '';
      if (E.backsSave) E.backsSave.textContent = p && S.backs ? ' You save ' + money(p.saved) + '.' : '';
      if (!S.adding) E.cart.textContent = p ? 'Add to cart \u00b7 ' + money(p.final) : 'Add to cart';
      if (E.currency) E.currency.hidden = !cfg.currency || cfg.currency === 'USD';
      if (E.mail) E.mail.href = mailHref();
      renderDate();
    }

    /* -- the file row in step 3 -- */
    function openCount() { return currentFindings().filter(function (f) { return !f.ok && !f.answered; }).length; }
    function renderArtStep() {
      var hasFile = !!S.file;
      E.artpick.hidden = hasFile || S.noFileYet;
      E.filerow.hidden = !(hasFile || S.noFileYet);
      E.artlabel.textContent = hasFile ? 'Your artwork' : 'Add your artwork';
      E.rightsbox.hidden = !(hasFile || S.noFileYet);
      if (E.intro) E.intro.hidden = hasFile;
      if (E.proofline) E.proofline.hidden = hasFile;
      if (!hasFile && !S.noFileYet) return;
      var icon, main, sub, cls;
      var warn = '<svg class="tsps-filerow__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9A6A00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l9.5 17h-19L12 3z"/><path d="M12 10v4.5M12 17.5v.5"/></svg>';
      var ok = '<svg class="tsps-filerow__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1F6E5C" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      var doc = '<svg class="tsps-filerow__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1B2D4F" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/></svg>';
      if (S.noFileYet && !hasFile) {
        cls = ''; icon = doc;
        main = 'No file yet';
        sub = 'Add it on your order page after checkout. We send the link right away.';
        E.filerow.className = 'tsps-filerow';
        E.filerow.innerHTML = icon + '<span class="tsps-filerow__main">' + main + '<span class="tsps-filerow__sub">' + sub + '</span></span><button type="button" class="tsps-link" data-tsps-choose>Choose a file now</button>';
        return;
      }
      var name = esc(S.file.name) + (S.art && !S.art.noPreview ? ' \u00b7 ' + LOOK_WORDS[S.look] : '');
      var n = S.art && !S.art.noPreview ? openCount() : 0;
      if (S.art && S.art.failed) { cls = 'is-look'; icon = warn; sub = 'We saved it, but couldn\u2019t open it here.'; }
      else if (!S.art) { cls = ''; icon = doc; sub = 'Opening your file\u2026'; }
      else if (S.art.noPreview) { cls = ''; icon = doc; sub = 'Saved for our team. No preview for this kind of file.'; }
      else if (n) { cls = 'is-look'; icon = warn; sub = '<a href="#' + E.lookbox.id + '" class="tsps-link" data-tsps-tolook>' + (n === 1 ? '1 thing to look at' : n + ' things to look at') + '</a>'; }
      else if (!checksDone()) { cls = ''; icon = doc; sub = 'Checking your file\u2026'; }
      else { cls = 'is-ok'; icon = ok; sub = 'File checked'; }
      E.filerow.className = 'tsps-filerow' + (cls ? ' ' + cls : '');
      E.filerow.innerHTML = icon + '<span class="tsps-filerow__main">' + name + '<span class="tsps-filerow__sub">' + sub + '</span></span><button type="button" class="tsps-link" data-tsps-change>Change</button>';
    }

    /* -- dates -- */
    function renderDate() {
      if (!S.lead) return;
      var lead = S.lead, today = utahToday();
      var proof = lead.addBizDays(today, lead.designDays);
      var ship = lead.shipDays ? lead.shipDays(S.qty) : lead.printDays;
      var soonest = lead.addBizDays(proof, ship + 1);
      E.date.hidden = false;
      E.datetext.innerHTML = '<strong>' + esc(lead.fmt(soonest)) + '</strong> is the soonest you could have them: approve your proof ' + esc(dayWord(proof, today)) + ' and pick Next Day Air at checkout.';
      /* the date line under the intro (the Process Bar's, folded in): the
         same days, so the two always agree; big amounts add their days */
      if (E.when) {
        var whenSet = function (sel, text) { var el = qs(E.when, sel); if (el) el.textContent = text; };
        whenSet('[data-tsps-when-today]', 'today (' + today.toLocaleDateString('en-US', { weekday: 'short' }) + ')');
        whenSet('[data-tsps-when-proof]', lead.designDays > 0 ? lead.fmt(proof) : 'today');
        whenSet('[data-tsps-when-ship]', ship === 1 ? '1 business day' : ship + ' business days');
        E.when.classList.remove('is-wait');
      }
      if (E.fast && !E.fast.__tspsFixed) {
        var p1 = lead.designDays <= 0 ? 'Proof the same business day' : lead.designDays === 1 ? 'Proof by the next business day' : 'Proof within ' + lead.designDays + ' business days';
        var s1 = 'it ships within ' + lead.printDays + ' business day' + (lead.printDays === 1 ? '' : 's') + ' of your yes.';
        if (/^Proof by the next business day, and it ships within 1 business day of your yes\.?$/.test(E.fast.textContent.trim())) E.fast.textContent = p1 + ', and ' + s1;
        E.fast.__tspsFixed = true;
      }
    }

    /* === their art === */
    function curVer() { return S.art ? (S.art.useRaw ? S.art.raw : S.art.clean) : null; }
    var layoutCache = {};
    function layoutKey(look, size, verName) { return verName + '|' + look + '|' + size; }
    function verName() { return S.art && S.art.useRaw ? 'raw' : 'clean'; }
    function bgFor(ver) {
      if (!S.art) return '#FFFFFF';
      if (ver === S.art.clean && !S.art.removed && S.art.border.kind === 'solid' && S.art.border.color) {
        var c = S.art.border.color;
        return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')';
      }
      return '#FFFFFF';
    }
    function analyticLayout(look, size, ver) {
      var Sz = num(size), pad, k, artBox;
      if (look === 'circle') {
        pad = Math.max(0.12, 0.06 * Sz);
        var inner = Sz / 2 - pad, mec = ver.mec;
        k = inner / mec.r;
        artBox = { x: Sz / 2 - mec.cx * k, y: Sz / 2 - mec.cy * k, w: ver.w * k, h: ver.h * k };
        return { look: look, size: size, kind: 'circle', wIn: Sz, hIn: Sz, artBox: artBox, bg: bgFor(ver) };
      }
      pad = Math.max(0.1, 0.06 * Sz);
      var innerS = Sz - 2 * pad;
      k = Math.min(innerS / ver.w, innerS / ver.h);
      artBox = { x: (Sz - ver.w * k) / 2, y: (Sz - ver.h * k) / 2, w: ver.w * k, h: ver.h * k };
      return { look: look, size: size, kind: 'rounded', radius: 0.14 * Sz, wIn: Sz, hIn: Sz, artBox: artBox, bg: bgFor(ver) };
    }
    function fieldLayout(look, size, f) {
      var R = f.R, bb = f.cut;
      return {
        look: look, size: size, kind: 'field', field: f, bg: '#FFFFFF',
        wIn: (bb.x1 - bb.x0) / R, hIn: (bb.y1 - bb.y0) / R,
        artBox: { x: (f.art.x - bb.x0) / R, y: (f.art.y - bb.y0) / R, w: f.art.w / R, h: f.art.h / R }
      };
    }
    /* the layout if it's ready (cut shapes take a moment), else null */
    function layoutNow(look, size, vname) {
      var art = S.art;
      if (!art || art.noPreview || art.failed) return null;
      vname = vname || verName();
      var ver = vname === 'raw' ? art.raw : art.clean;
      if (look === 'circle' || look === 'square') return analyticLayout(look, size, ver);
      return layoutCache[layoutKey(look, size, vname)] || null;
    }
    /* the layout, waiting for the cut shape if needed */
    var fieldJobs = {};
    function layoutFor(look, size, vname) {
      var now = layoutNow(look, size, vname);
      if (now) return Promise.resolve(now);
      var art = S.art;
      if (!art || art.noPreview || art.failed) return Promise.resolve(null);
      vname = vname || verName();
      var key = layoutKey(look, size, vname), turn = S.turn;
      if (fieldJobs[key + '|' + turn]) return fieldJobs[key + '|' + turn];
      var ver = vname === 'raw' ? art.raw : art.clean;
      var job = Analysis.call('cutField', { alpha: ver.alpha, w: ver.w, h: ver.h, sizeIn: num(size), bandIn: look === 'die_cut' ? BAND_IN : 0, R: FIELD_R })
        .then(function (f) {
          if (turn !== S.turn || !f) return null;
          var L = fieldLayout(look, size, f);
          layoutCache[key] = L;
          return L;
        });
      fieldJobs[key + '|' + turn] = job;
      return job;
    }
    /* art inches across, for a size we haven't laid out yet (close enough
       for "At 4" it's about 10 pt"; the real one replaces it soon) */
    function artWidthIn(look, size, vname) {
      var L = layoutNow(look, size, vname);
      if (L) return L.artBox.w;
      var ver = vname === 'raw' ? S.art.raw : S.art.clean, Sz = num(size), longRatio = ver.w / Math.max(ver.w, ver.h);
      if (look === 'die_cut') return (Sz - 2 * BAND_IN) * longRatio;
      return Sz * longRatio;
    }

    function prepVersion(v) {
      var c = makeCanvas(v.w, v.h);
      c.getContext('2d').putImageData(new ImageData(new Uint8ClampedArray(v.data.buffer, v.data.byteOffset, v.data.length), v.w, v.h), 0, 0);
      var alpha = new Uint8Array(v.w * v.h);
      for (var i = 0, p = 3; i < alpha.length; i++, p += 4) alpha[i] = v.data[p];
      return { canvas: c, w: v.w, h: v.h, data: v.data, alpha: alpha, box: v.box };
    }
    /* their opened file: shrink to the working size, clean it, trim it */
    function prepareArt(dec) {
      var src = dec.canvas, s = Math.min(1, WORK_MAX / Math.max(src.width, src.height));
      var wc = makeCanvas(src.width * s, src.height * s), wx = wc.getContext('2d');
      wx.imageSmoothingEnabled = true; wx.imageSmoothingQuality = 'high';
      wx.drawImage(src, 0, 0, wc.width, wc.height);
      var id = wx.getImageData(0, 0, wc.width, wc.height);
      return Analysis.call('prepare', { w: wc.width, h: wc.height, data: id.data }).then(function (r) {
        if (r.empty) { var e = new Error('nothing in the file'); e.empty = true; throw e; }
        var art = {
          kind: dec.kind, vector: dec.vector, pages: dec.pages || 1,
          natW: dec.natW, natH: dec.natH, workW: wc.width, workH: wc.height,
          natPerWork: dec.natW / wc.width,
          border: r.border, removed: r.removed, useRaw: false,
          clean: prepVersion(r.clean), raw: prepVersion(r.raw),
          pdfScale: dec.pdfScale || 0, pdfImages: dec.pdfImages || null, pdfReader: dec.pdfReader || '',
          checks: { words: null, details: null, qr: null }
        };
        return Promise.all([
          Analysis.call('enclosingCircle', { alpha: art.clean.alpha, w: art.clean.w, h: art.clean.h }),
          Analysis.call('enclosingCircle', { alpha: art.raw.alpha, w: art.raw.w, h: art.raw.h })
        ]).then(function (m) { art.clean.mec = m[0]; art.raw.mec = m[1]; return art; });
      });
    }

    /* === the file checks === */
    function checksDone() {
      var a = S.art;
      if (!a || a.noPreview || a.failed) return true;
      return a.checks.words !== null && a.checks.details !== null && a.checks.qr !== null;
    }
    /* clean-version pixels to the version on screen */
    function toVer(b, vname) {
      if (vname !== 'raw' || !S.art) return b;
      var dx = S.art.clean.box.x - S.art.raw.box.x, dy = S.art.clean.box.y - S.art.raw.box.y;
      return { x0: b.x0 + dx, y0: b.y0 + dy, x1: b.x1 + dx, y1: b.y1 + dy };
    }
    /* picture for the checks: the clean art over white (the vinyl), at a
       steady working size */
    /* A white margin goes all the way around (the vinyl around a design is
       white), so the art never touches the picture's edge: an edge would
       look like a hairline to the details check. */
    function analysisImage(art) {
      var v = art.clean, s = ANALYSIS_MAX / Math.max(v.w, v.h);
      var aw = Math.max(8, Math.round(v.w * s)), ah = Math.max(8, Math.round(v.h * s)), pad = 24;
      var W = aw + 2 * pad, H = ah + 2 * pad;
      var c = makeCanvas(W, H), x = c.getContext('2d');
      x.fillStyle = '#FFFFFF'; x.fillRect(0, 0, W, H);
      x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
      x.drawImage(v.canvas, pad, pad, aw, ah);
      var rgba = x.getImageData(0, 0, W, H).data, lum = new Uint8Array(W * H);
      for (var i = 0, p = 0; i < lum.length; i++, p += 4) lum[i] = (rgba[p] * 0.299 + rgba[p + 1] * 0.587 + rgba[p + 2] * 0.114) | 0;
      var ac = makeCanvas(W, H), ax = ac.getContext('2d');
      ax.drawImage(v.canvas, pad, pad, aw, ah);
      var ad = ax.getImageData(0, 0, W, H).data, alpha = new Uint8Array(W * H);
      for (var j = 0, q = 3; j < alpha.length; j++, q += 4) alpha[j] = ad[q];
      return { w: W, h: H, lum: lum, rgba: rgba, alpha: alpha, perClean: v.w / aw, pad: pad };
    }
    /* The picture the word reader gets: their art blown up so small words
       have enough pixels. The second one is inverted, because the reader
       is much better at dark words on light than light words on a color
       (white words on a navy circle). */
    function ocrCanvas(art, inverted) {
      var v = art.clean, longSide = Math.max(v.w, v.h);
      var f = clamp(1900 / longSide, 1, 3), pad = Math.round(longSide * f * 0.03);
      var W = Math.round(v.w * f) + 2 * pad, H = Math.round(v.h * f) + 2 * pad;
      var c = makeCanvas(W, H), x = c.getContext('2d');
      x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
      if (inverted) {
        x.fillStyle = '#000000'; x.fillRect(0, 0, W, H);
        x.drawImage(v.canvas, pad, pad, Math.round(v.w * f), Math.round(v.h * f));
        var id = x.getImageData(0, 0, W, H), d2 = id.data;
        for (var j = 0; j < d2.length; j += 4) { d2[j] = 255 - d2[j]; d2[j + 1] = 255 - d2[j + 1]; d2[j + 2] = 255 - d2[j + 2]; d2[j + 3] = 255; }
        x.putImageData(id, 0, 0);
        return { canvas: c, f: f, pad: pad };
      }
      var light = 0, opaque = 0, d = v.data;
      for (var i = 0; i < d.length; i += 16) { if (d[i + 3] < 200) continue; opaque++; if (d[i] > 225 && d[i + 1] > 225 && d[i + 2] > 225) light++; }
      var dark = opaque > 0 && light / opaque > 0.25;
      x.fillStyle = dark ? '#3A3A3A' : '#FFFFFF'; x.fillRect(0, 0, W, H);
      x.drawImage(v.canvas, pad, pad, Math.round(v.w * f), Math.round(v.h * f));
      return { canvas: c, f: f, pad: pad };
    }
    function boxOverlap(a, b) {
      var ix = Math.max(0, Math.min(a.x1, b.x1) - Math.max(a.x0, b.x0)), iy = Math.max(0, Math.min(a.y1, b.y1) - Math.max(a.y0, b.y0));
      var small = Math.min((a.x1 - a.x0) * (a.y1 - a.y0), (b.x1 - b.x0) * (b.y1 - b.y0));
      return small > 0 ? ix * iy / small : 0;
    }
    function startChecks(art, turn) {
      var an = analysisImage(art);
      art.an = { w: an.w, h: an.h, perClean: an.perClean, pad: an.pad };
      /* small details */
      var ppt = (an.w - 2 * an.pad) / (Math.max(0.5, artWidthIn('die_cut', '2.5', 'clean')) * 72);
      var D = Math.max(3, Math.min(41, Math.ceil(cut.linePt * ppt * 1.7)));
      if (D % 2 === 0) D++;
      Analysis.call('details', { lum: an.lum, alpha: an.alpha, w: an.w, h: an.h, D: D, cmin: 56 }).then(function (r) {
        if (turn !== S.turn) return;
        art.checks.details = r;
        checksChanged();
      }, function () { if (turn !== S.turn) return; art.checks.details = { feats: [], photo: 0, failed: true }; checksChanged(); });
      /* QR codes */
      Analysis.call('qrFind', { lum: an.lum, w: an.w, h: an.h }).then(function (found) {
        var crops = found.map(function (q) { return { x: q.cx - q.side * 0.85, y: q.cy - q.side * 0.85, w: q.side * 1.7, h: q.side * 1.7 }; });
        return Analysis.call('jsqrScan', { rgba: an.rgba, w: an.w, h: an.h, url: LIBS.jsqr, crops: crops }).then(function (r) {
          var codes = (r && r.codes) || [];
          found.forEach(function (q) {
            for (var i = 0; i < codes.length; i++) if (Math.abs(codes[i].cx - q.cx) < q.side / 2 && Math.abs(codes[i].cy - q.cy) < q.side / 2) return;
            codes.push({ cx: q.cx, cy: q.cy, side: q.side, decoded: false });
          });
          return codes;
        }, function () { return found.map(function (q) { return { cx: q.cx, cy: q.cy, side: q.side, decoded: false }; }); });
      }).then(function (codes) {
        if (turn !== S.turn) return;
        art.checks.qr = codes.map(function (q) {
          var k = an.perClean;
          return { cx: (q.cx - an.pad) * k, cy: (q.cy - an.pad) * k, side: q.side * k, decoded: q.decoded };
        });
        checksChanged();
      }, function () { if (turn !== S.turn) return; art.checks.qr = []; checksChanged(); });
      /* small words: read twice (as is, then inverted), the same words
         found twice count once */
      var oc = ocrCanvas(art, false), oc2 = ocrCanvas(art, true);
      function mapLines(lines, o) {
        return lines.map(function (l) {
          return { text: l.text, allCaps: l.allCaps, conf: l.conf, x0: (l.x0 - o.pad) / o.f, y0: (l.y0 - o.pad) / o.f, x1: (l.x1 - o.pad) / o.f, y1: (l.y1 - o.pad) / o.f };
        });
      }
      withTimeout(readWords(oc.canvas), 60000, 'word reader').then(function (l1) {
        var found = mapLines(l1, oc);
        if (turn !== S.turn) return found;
        return withTimeout(readWords(oc2.canvas), 45000, 'word reader').then(function (l2) {
          mapLines(l2, oc2).forEach(function (b) {
            if (!found.some(function (a) { return boxOverlap(a, b) > 0.3; })) found.push(b);
          });
          return found;
        }, function () { return found; });
      }).then(function (mapped) {
        return Analysis.call('measureLines', { img: { w: art.clean.w, h: art.clean.h, data: art.clean.data }, lines: mapped });
      }).then(function (m) {
        if (turn !== S.turn) return;
        art.checks.words = { lines: m };
        checksChanged();
      }, function () {
        if (turn !== S.turn) return;
        art.checks.words = { lines: [], failed: true };
        checksChanged();
      });
    }

    /* -- turning measurements into plain messages -- */
    function ptPerCleanPx(look, size, vname) { return artWidthIn(look, size, vname) * 72 / S.art.clean.w; }
    function biggerSizes() { return SIZES.filter(function (s) { return num(s) > num(S.size); }); }
    function smallerSizes() { return SIZES.filter(function (s) { return num(s) < num(S.size); }).reverse(); }
    function wordBoxes() {
      var w = S.art && S.art.checks.words;
      return w && w.lines ? w.lines : [];
    }
    function inAnyWordBox(b) {
      var lines = wordBoxes();
      for (var i = 0; i < lines.length; i++) {
        /* sideways a letter's width or so: the reader sometimes leaves off
           the first or last letter ("quiptcare.ca") */
        var l = lines[i], padY = (l.y1 - l.y0) * 0.35, padX = (l.y1 - l.y0) * 0.9;
        var cx = (b.x0 + b.x1) / 2, cy = (b.y0 + b.y1) / 2;
        if (cx >= l.x0 - padX && cx <= l.x1 + padX && cy >= l.y0 - padY && cy <= l.y1 + padY) return true;
      }
      return false;
    }
    function inAnyQr(b) {
      var qrs = (S.art && S.art.checks.qr) || [];
      var cx = (b.x0 + b.x1) / 2, cy = (b.y0 + b.y1) / 2;
      for (var i = 0; i < qrs.length; i++) {
        var q = qrs[i], half = q.side * 0.62;
        if (Math.abs(cx - q.cx) <= half && Math.abs(cy - q.cy) <= half) return true;
      }
      return false;
    }
    function detailsAt(look, size, vname) {
      var d = S.art.checks.details;
      if (!d || d.failed || !d.feats || d.photo > 0.42) return null;
      var k = S.art.an.perClean, pd = S.art.an.pad || 0, ppx = ptPerCleanPx(look, size, vname) * k, thin = [], dots = [];
      d.feats.forEach(function (f) {
        var wpt = f.w * ppx;
        if (wpt >= cut.linePt) return;
        if (d.photoGrid) {
          var gx = (((f.x0 + f.x1) / 2) / d.gb) | 0, gy = (((f.y0 + f.y1) / 2) / d.gb) | 0;
          if (d.photoGrid[gy * d.gw + gx]) return;
        }
        var b = { x0: (f.x0 - pd) * k, y0: (f.y0 - pd) * k, x1: (f.x1 - pd) * k, y1: (f.y1 - pd) * k };
        if (inAnyWordBox(b) || inAnyQr(b)) return;
        var bw = f.x1 - f.x0, bh = f.y1 - f.y0, longest = Math.max(bw, bh);
        var item = { b: b, wpt: wpt, lenpt: f.len * ppx, w: f.w };
        if (f.len >= 3 * f.w && longest >= 3 * f.w) thin.push(item);
        else if (longest <= 3.2 * f.w + 1) dots.push(item);
      });
      var totalLen = thin.reduce(function (s, t) { return s + t.lenpt; }, 0);
      var longLine = thin.some(function (t) { return t.lenpt >= 14; });
      var linesFlag = totalLen >= 22 || longLine || thin.length >= 8;
      var dotsFlag = dots.length >= 14;
      if (!linesFlag && !dotsFlag) return { ok: true };
      var useLines = linesFlag && (!dotsFlag || totalLen >= dots.length * 1.5);
      var items = useLines ? thin : dots;
      var ws = items.map(function (t) { return t.wpt; }).sort(function (a, b) { return a - b; });
      var med = ws[ws.length >> 1];
      return { ok: false, kind: useLines ? 'lines' : 'dots', pt: med, items: items };
    }
    /* One mark where the thin bits are thickest on the ground: the
       busiest spot on a 6 x 6 grid, plus the neighbors that are nearly as
       busy, so the circle points at a place instead of the whole sticker. */
    function clusterMark(items) {
      var ar = S.art.clean, G = 6, cells = {};
      function cellOf(t) {
        var cx = (t.b.x0 + t.b.x1) / 2, cy = (t.b.y0 + t.b.y1) / 2;
        return [Math.max(0, Math.min(G - 1, Math.floor(cx / ar.w * G))), Math.max(0, Math.min(G - 1, Math.floor(cy / ar.h * G)))];
      }
      items.forEach(function (t) {
        var c = cellOf(t), key = c[0] + ',' + c[1];
        cells[key] = (cells[key] || 0) + Math.max(1, t.lenpt || 1);
      });
      var bestKey = null, best = -1;
      Object.keys(cells).forEach(function (kk) { if (cells[kk] > best) { best = cells[kk]; bestKey = kk; } });
      if (!bestKey) return null;
      var gx = parseInt(bestKey.split(',')[0], 10), gy = parseInt(bestKey.split(',')[1], 10);
      var b = { x0: Infinity, y0: Infinity, x1: -Infinity, y1: -Infinity };
      items.forEach(function (t) {
        var c = cellOf(t);
        if (Math.abs(c[0] - gx) > 1 || Math.abs(c[1] - gy) > 1) return;
        if ((c[0] !== gx || c[1] !== gy) && (cells[c[0] + ',' + c[1]] || 0) < best * 0.5) return;
        b.x0 = Math.min(b.x0, t.b.x0); b.y0 = Math.min(b.y0, t.b.y0); b.x1 = Math.max(b.x1, t.b.x1); b.y1 = Math.max(b.y1, t.b.y1);
      });
      return isFinite(b.x0) ? b : null;
    }
    /* Everything to show for the size and look on screen. */
    function currentFindings() {
      var art = S.art;
      if (!art || art.noPreview || art.failed) return [];
      var vname = verName(), ver = curVer(), size = S.size, look = S.look, out = [];
      var sz = inch(size);
      /* sharpness at their size: the design's own pixels, not the canvas */
      var ppi = null;
      if (!art.vector) ppi = (ver.w * art.natPerWork) / artWidthIn(look, size, vname);
      else if (art.pdfImages && art.pdfImages.images && art.pdfImages.images.length) {
        /* a PDF that's mostly one picture: that picture's pixels */
        var pg = art.pdfImages, cleanWpt = art.clean.w * art.natPerWork / art.pdfScale;
        var big = pg.images.filter(function (im) { return im.dwPt * im.dhPt >= 0.15 * cleanWpt * (art.clean.h * art.natPerWork / art.pdfScale); });
        if (big.length) {
          var worst = Infinity;
          big.forEach(function (im) {
            var inchesAcross = (im.dwPt / cleanWpt) * artWidthIn(look, size, vname);
            worst = Math.min(worst, im.w / inchesAcross);
          });
          if (isFinite(worst)) ppi = worst;
        }
      }
      if (ppi !== null && ppi < cut.sharpPpi) {
        var fixS = null;
        smallerSizes().forEach(function (s) {
          if (fixS) return;
          var p2 = (ver.w * art.natPerWork) * (ppi / (ver.w * art.natPerWork)) * (artWidthIn(look, size, vname) / artWidthIn(look, s, vname));
          if (p2 >= cut.sharpPpi) fixS = s;
        });
        out.push({
          key: 'sharp', metric: ppi, fix: fixS,
          html: '<strong>Your file is small for ' + sz + ':</strong> it would print a little soft. ' + (fixS ? 'It prints sharp at ' + inch(fixS) + ', or upload a bigger copy of the same art.' : 'A bigger copy of the same art prints sharp.'),
          buttons: fixS ? [['size:' + fixS, 'Switch to ' + inch(fixS), true], ['upload', 'Upload a bigger file'], ['keep', 'Keep ' + sz]] : [['upload', 'Upload a bigger file', true], ['keep', 'Keep it as is']],
          summary: 'Saw the file is small for ' + sz + ' (about ' + Math.round(ppi) + ' pixels per inch)'
        });
      }
      /* small words */
      var words = art.checks.words;
      if (words && words.lines && words.lines.length) {
        var ppx = ptPerCleanPx(look, size, vname);
        var sized = words.lines.map(function (l) { return { l: l, pt: l.heightPx * ppx / l.em }; }).sort(function (a, b) { return a.pt - b.pt; });
        var small = sized.filter(function (x) { return x.pt < cut.wordsPt; });
        if (small.length) {
          var s0 = small[0], fixW = null, fixPt = 0;
          biggerSizes().forEach(function (s) {
            if (fixW) return;
            var r = ptPerCleanPx(look, s, vname) / ppx;
            if (small.every(function (x) { return x.pt * r >= cut.wordsPt + 0.15; })) { fixW = s; fixPt = s0.pt * r; }
          });
          var text = String(s0.l.text).trim(), quote = text.length > 34 ? text.slice(0, 34).replace(/[\s,;:.]+\S*$/, '') + '\u2026' : text;
          var quotable = isQuotable(text);
          /* never "about 10 pt" for words under 10 */
          var ptShown = Math.min(Math.max(1, Math.round(s0.pt)), Math.ceil(cut.wordsPt) - 1);
          var more = small.length > 1 ? ' (' + small.length + ' lines are under ' + cut.wordsPt + ' pt.)' : '';
          out.push({
            key: 'words', metric: s0.pt, fix: fixW,
            mark: toVer(boxOf(small.slice(0, 1).map(function (x) { return x.l; })), vname),
            html: '<strong>Small words:</strong> ' + (quotable ? '\u201c' + esc(quote) + '\u201d comes' : 'the words marked {n} come') + ' out about ' + ptShown + ' pt at ' + sz + ', too small to read on our texture. ' +
              (fixW ? 'At ' + inch(fixW) + ' ' + (quotable ? 'it\u2019s' : 'they\u2019re') + ' about ' + Math.max(Math.round(fixPt), Math.ceil(cut.wordsPt)) + ' pt and ' + (quotable ? 'reads' : 'read') + ' clearly.' : 'Words need about ' + cut.wordsPt + ' pt.') + more,
            buttons: fixW ? [['size:' + fixW, 'Switch to ' + inch(fixW), true], ['keep', 'Keep ' + sz], ['upload', 'Upload a different file']] : [['upload', 'Upload a different file', true], ['keep', 'Keep it as is']],
            summary: 'Saw small words (' + (quotable ? '\u201c' + quote + '\u201d, ' : '') + 'about ' + ptShown + ' pt)'
          });
        } else {
          out.push({ key: 'words', ok: true, okText: 'The words we found read clearly at ' + sz + '.' });
        }
      }
      /* QR codes: at least 0.6" across at their size */
      var qrs = art.checks.qr;
      if (qrs && qrs.length) {
        var inPerPx = artWidthIn(look, size, vname) / art.clean.w;
        var q0 = qrs.slice().sort(function (a, b) { return a.side - b.side; })[0], qIn = q0.side * inPerPx;
        if (qIn < cut.qrIn) {
          var fixQ = null;
          biggerSizes().forEach(function (s) { if (!fixQ && q0.side * artWidthIn(look, s, vname) / art.clean.w >= cut.qrIn + 0.01) fixQ = s; });
          var yoursPx = clamp(Math.round(60 * qIn / cut.qrIn), 8, 60);
          out.push({
            key: 'qr', metric: qIn, fix: fixQ,
            mark: toVer({ x0: q0.cx - q0.side / 2, y0: q0.cy - q0.side / 2, x1: q0.cx + q0.side / 2, y1: q0.cy + q0.side / 2 }, vname),
            html: '<strong>Your QR code won\u2019t scan:</strong> it comes out ' + qIn.toFixed(qIn < 0.1 ? 2 : 1) + '" across at ' + sz + '. On our texture a QR code needs to be at least ' + cut.qrIn + '" across.',
            qr: { yours: yoursPx, yoursIn: qIn },
            buttons: fixQ ? [['size:' + fixQ, 'Switch to ' + inch(fixQ), true], ['upload', 'Upload a file with a bigger code'], ['keep', 'Keep it anyway']] : [['upload', 'Upload a file with a bigger code', true], ['keep', 'Keep it anyway']],
            summary: 'Saw a small QR code (' + qIn.toFixed(2) + '" across)'
          });
        } else {
          out.push({ key: 'qr', ok: true, okText: 'Your QR code is big enough to scan at ' + sz + ' (about ' + qIn.toFixed(1) + '" across).' });
        }
      }
      /* small details */
      if (art.checks.details && words && art.checks.qr) {
        var dt = detailsAt(look, size, vname);
        if (dt && !dt.ok) {
          var fixD = null;
          biggerSizes().forEach(function (s) {
            if (fixD) return;
            var r = ptPerCleanPx(look, s, vname) / ptPerCleanPx(look, size, vname);
            var still = dt.items.filter(function (t) { return t.wpt * r < cut.linePt; }).length;
            if (still <= dt.items.length * 0.2) fixD = s;
          });
          var ptTxt = dt.pt < 0.95 ? round1(Math.max(0.1, dt.pt)) : round1(dt.pt);
          var isLines = dt.kind === 'lines';
          out.push({
            key: 'details', metric: dt.pt, fix: fixD,
            mark: toVer(clusterMark(dt.items), vname),
            html: '<strong>Small details:</strong> ' + (isLines
              ? 'some lines in your design are about ' + ptTxt + ' pt thick at ' + sz + '. Lines that thin won\u2019t print crisp on our texture: they can look soft or fade.'
              : 'some dots in your design are about ' + ptTxt + ' pt across at ' + sz + '. Dots that small won\u2019t print crisp on our texture: they can fade.'),
            buttons: fixD ? [['size:' + fixD, 'Switch to ' + inch(fixD), true], ['keep', 'Keep it as is'], ['upload', 'Upload a different file']] : [['upload', 'Upload a different file', true], ['keep', 'Keep it as is']],
            summary: isLines ? 'Saw thin lines (about ' + ptTxt + ' pt)' : 'Saw tiny dots (about ' + ptTxt + ' pt)'
          });
        }
      }
      var looks = out.filter(function (f) { return !f.ok; }), n = 0;
      looks.forEach(function (f) {
        var a = S.answers[f.key];
        f.answered = !!(a && a.choice === 'keep' && f.metric >= a.metric * 0.95);
        f.n = ++n;
        f.html = f.html.replace('{n}', String(f.n));
      });
      return out;
    }
    /* Quote what the word reader saw only when it's a real word or line:
       half of a curved word ("earts" from "Lionhearts") would just confuse
       people, so then the message points at the numbered mark instead. */
    function isQuotable(text) {
      var t = String(text || '').trim(), words = t.split(/\s+/).filter(Boolean), letters = t.replace(/[^A-Za-z]/g, '');
      if (/\d{3}/.test(t) || /[a-z0-9-]\.(com|org|net|edu|gov|ca|us|io|co|info|biz)\b/i.test(t)) return true;
      if (words.length >= 2) return letters.length >= 5;
      if (letters.length >= 6 && /^[A-Za-z][a-z]+$|^[A-Z]+$/.test(t)) return true;
      return letters.length >= 4 && (/^[A-Z]+$/.test(t) || /^[A-Z][a-z]+$/.test(t));
    }
    function boxOf(lines) {
      var b = { x0: Infinity, y0: Infinity, x1: -Infinity, y1: -Infinity };
      lines.forEach(function (l) { b.x0 = Math.min(b.x0, l.x0); b.y0 = Math.min(b.y0, l.y0); b.x1 = Math.max(b.x1, l.x1); b.y1 = Math.max(b.y1, l.y1); });
      return b;
    }

    var lastFindings = [];
    function renderFindings() {
      var art = S.art, fs = currentFindings();
      lastFindings = fs;
      var looks = fs.filter(function (f) { return !f.ok; });
      var openN = looks.filter(function (f) { return !f.answered; }).length;
      /* one box: what needs a look first, then everything that passed folded
         into one line. Its color and its otter say what's going on: the
         magnifying glass while there's something to look at (or the check
         is running), the cheering otter when it's all good. */
      var plain = !art || art.noPreview || art.failed, waiting = !!art && !plain && !checksDone();
      var state = plain ? 'plain' : openN ? 'look' : waiting ? 'wait' : looks.length ? 'set' : 'good';
      var okIcon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1F6E5C" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      var warnIcon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9A6A00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l9.5 17h-19L12 3z"/><path d="M12 10v4.5M12 17.5v.5"/></svg>';
      if (plain || !looks.length) {
        E.lookbox.hidden = true;
        E.lookbox.innerHTML = '';
      } else {
        E.lookbox.hidden = false;
        var head = openN === 0
          ? okIcon + '<span>' + (waiting ? 'Checking the rest of your file\u2026' : 'All set!') + '</span>'
          : warnIcon + '<span>' + (openN === 1 ? '1 thing' : openN + ' things') + ' to look at before you order</span>';
        E.lookbox.innerHTML = '<div class="tsps-lookbox__head">' + head + '</div>' + looks.map(function (f) {
          var body = '<div class="tsps-li__text"><span class="tsps-li__num" aria-hidden="true">' + (f.answered ? '&#10003;' : f.n) + '</span><span>' + f.html + '</span></div>';
          if (f.qr && !f.answered) {
            body += '<div class="tsps-li__qr"><figure>' + qrSvg(f.qr.yours, '#1B2D4F', false) + '<figcaption>yours: ' + f.qr.yoursIn.toFixed(f.qr.yoursIn < 0.1 ? 2 : 1) + '"</figcaption></figure>' +
              '<figure>' + qrSvg(60, '#1B2D4F', true) + '<figcaption>needs: ' + cut.qrIn + '"</figcaption></figure></div>';
          }
          if (f.answered) {
            var a = S.answers[f.key];
            body += '<div class="tsps-li__again">You chose: ' + esc(a.label) + '. <button type="button" class="tsps-link" data-tsps-reask="' + f.key + '">Change</button></div>';
          } else {
            body += '<div class="tsps-li__btns">' + f.buttons.map(function (b) {
              return '<button type="button" class="tsps-pill' + (b[2] ? ' tsps-pill--go' : '') + '" data-tsps-do="' + esc(b[0]) + '" data-tsps-key="' + f.key + '" data-tsps-label="' + esc(b[1]) + '">' + esc(b[1]) + '</button>';
            }).join('') + '</div>';
          }
          return '<div class="tsps-li' + (f.answered ? ' is-answered' : '') + '">' + body + '</div>';
        }).join('');
      }
      E.good.hidden = state !== 'good';
      E.checks.classList.toggle('is-look', state === 'look');
      E.checks.classList.toggle('is-good', state === 'good' || state === 'set');
      var otter = state === 'look' || state === 'wait' ? 'look' : state === 'good' || state === 'set' ? 'cheer' : '';
      E.otters.forEach(function (o) { o.hidden = o.getAttribute('data-tsps-otter') !== otter; });
      E.checks.classList.toggle('has-otter', !!otter);
      /* everything that passed; the lines that matter on their own (the
         white box, a PDF's other pages, the check still running, a file we
         can't show) always show, the rest fold into one line */
      var lines = [], passed = 0, keyLi = '<li class="is-key">';
      if (art && art.failed) {
        lines.push(keyLi + '<span class="tsps-ok" aria-hidden="true">&#10003;</span><span>We saved your file for our team. It wouldn\u2019t open here, so you won\u2019t see the four looks, but you can still order and see your proof before anything prints.</span></li>');
      } else if (art && art.noPreview) {
        lines.push(keyLi + '<span class="tsps-ok" aria-hidden="true">&#10003;</span><span>We saved your ' + esc(extOf(S.file.name).toUpperCase()) + ' file for our team. We can\u2019t show a preview of this kind of file here, so pick a shape and our team opens it for your proof.</span></li>');
      } else if (art) {
        var sharpLook = looks.filter(function (f) { return f.key === 'sharp'; }).length;
        if (!sharpLook) {
          var every = art.vector || SIZES.every(function (s) { return (curVer().w * art.natPerWork) / artWidthIn(S.look, s, verName()) >= cut.sharpPpi; });
          passed++;
          lines.push('<li><span class="tsps-ok" aria-hidden="true">&#10003;</span><span>' + (every ? 'Sharp at every size: your file is ' + (art.vector ? 'a vector.' : 'big enough.') : 'Sharp at ' + inch(S.size) + ': your file is big enough.') + '</span></li>');
        }
        if (art.removed && !art.useRaw) lines.push(keyLi + '<span class="tsps-ok" aria-hidden="true">&#10003;</span><span>We took away the white box around your design, so the cut follows your art. <button type="button" class="tsps-link" data-tsps-putback>Put it back</button></span></li>');
        if (art.removed && art.useRaw) lines.push(keyLi + '<span class="tsps-ok" aria-hidden="true">&#10003;</span><span>Your white box is back, so it prints as part of your sticker. <button type="button" class="tsps-link" data-tsps-takeaway>Take it away again</button></span></li>');
        fs.forEach(function (f) { if (f.ok) { passed++; lines.push('<li><span class="tsps-ok" aria-hidden="true">&#10003;</span><span>' + esc(f.okText) + '</span></li>'); } });
        if (art.pages > 1) lines.push(keyLi + '<span class="tsps-ok" aria-hidden="true">&#10003;</span><span>Your PDF has ' + art.pages + ' pages. This shows page 1. Need the others too? Send us a note.</span></li>');
        if (!checksDone()) lines.push('<li class="is-key tsps-wait"><span class="tsps-spin" aria-hidden="true"></span><span>Checking small words and details\u2026</span></li>');
      } else if (S.file) {
        lines.push('<li class="is-key tsps-wait"><span class="tsps-spin" aria-hidden="true"></span><span>Opening your file\u2026</span></li>');
      }
      E.checked.innerHTML = lines.join('');
      E.checked.classList.toggle('is-folded', !S.detailsOpen);
      var showSum = passed > 0 && (state === 'look' || state === 'set' || state === 'good');
      E.sum.hidden = !showSum;
      if (showSum) {
        E.sum.innerHTML = '<span class="tsps-ok" aria-hidden="true">&#10003;</span><span>' + (state === 'good' ? 'Your file passed every check.' : 'Everything else passed.') + '</span>' +
          '<button type="button" class="tsps-link" data-tsps-details aria-expanded="' + (S.detailsOpen ? 'true' : 'false') + '">' + (S.detailsOpen ? 'Hide details' : 'See details') + '</button>';
      }
      renderArtStep();
    }
    function qrSvg(px, color, dashed) {
      return '<svg width="' + px + '" height="' + px + '" viewBox="0 0 21 21" aria-hidden="true"><rect width="21" height="21" fill="#FFFFFF"' + (dashed ? ' stroke="#1F6E5C" stroke-width="0.4" stroke-dasharray="1 0.8"' : '') + '/>' +
        '<rect x="1" y="1" width="6" height="6" fill="' + color + '"/><rect x="2.5" y="2.5" width="3" height="3" fill="#FFFFFF"/>' +
        '<rect x="14" y="1" width="6" height="6" fill="' + color + '"/><rect x="15.5" y="2.5" width="3" height="3" fill="#FFFFFF"/>' +
        '<rect x="1" y="14" width="6" height="6" fill="' + color + '"/><rect x="2.5" y="15.5" width="3" height="3" fill="#FFFFFF"/>' +
        '<rect x="9" y="2" width="2" height="2" fill="' + color + '"/><rect x="9" y="9" width="3" height="2" fill="' + color + '"/><rect x="13" y="12" width="2" height="3" fill="' + color + '"/>' +
        '<rect x="16" y="15" width="3" height="2" fill="' + color + '"/><rect x="10" y="16" width="2" height="3" fill="' + color + '"/></svg>';
    }

    /* === the four looks on screen === */
    var paintTimer = null, paintSeq = 0;
    function cssSize(el) { var r = el.getBoundingClientRect(); return { w: r.width, h: r.height }; }
    function dprNow() { return Math.min(2, window.devicePixelRatio || 1); }
    function marksFor(look) {
      if (look !== S.look) return [];
      return lastFindings.filter(function (f) { return !f.ok && !f.answered && f.mark && isFinite(f.mark.x0); })
        .map(function (f) { return { n: f.n, x0: f.mark.x0, y0: f.mark.y0, x1: f.mark.x1, y1: f.mark.y1 }; });
    }
    function paintLooks(onlyPicked) {
      clearTimeout(paintTimer);
      var seq = ++paintSeq;
      paintTimer = setTimeout(function () {
        var art = S.art;
        E.looks.forEach(function (btn) {
          var look = btn.getAttribute('data-tsps-look'), on = look === S.look;
          btn.classList.toggle('is-on', on);
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
          btn.tabIndex = on ? 0 : -1;
        });
        if (E.lookcap) E.lookcap.textContent = (LOOK_CAPS[S.look] || '') + ' Shown on our texture.';
        if (!art) { E.looks.forEach(function (b) { b.classList.add('is-busy'); }); if (E.yours) E.yours.classList.add('is-busy'); return; }
        /* the picked shape first: it's the big picture */
        var todo = E.looks.filter(function (b) { return !onlyPicked || b.getAttribute('data-tsps-look') === S.look; })
          .sort(function (a, b) { return (b.getAttribute('data-tsps-look') === S.look ? 1 : 0) - (a.getAttribute('data-tsps-look') === S.look ? 1 : 0); });
        var i = 0;
        (function next() {
          if (seq !== paintSeq || i >= todo.length) return;
          var btn = todo[i++], look = btn.getAttribute('data-tsps-look'), canvas = qs(btn, 'canvas'), picked = look === S.look;
          if (art.noPreview || art.failed) {
            btn.classList.remove('is-busy');
            paintPlaceholder(canvas, look, smallSide(btn));
            if (picked && E.big) { paintPlaceholder(E.big, look, bigSide()); E.yours.classList.remove('is-busy'); }
            requestAnimationFrame(next);
            return;
          }
          btn.classList.add('is-busy');
          if (picked && E.yours) E.yours.classList.add('is-busy');
          layoutFor(look, S.size).then(function (L) {
            if (seq !== paintSeq || !L || art !== S.art) return;
            var exactBefore = !!L._shown;
            L._shown = true;
            paintSmall(btn, L);
            if (picked) {
              paintBig(L);
              renderSizes();
              /* the exact cut for this size just arrived: the messages use
                 it from now on (the first ones used a close estimate), and
                 the marks on the big picture follow them */
              if (!exactBefore && L.kind === 'field') { renderFindings(); renderTotal(); paintBig(L); }
            }
          }).catch(function () { btn.classList.remove('is-busy'); if (picked && E.yours) E.yours.classList.remove('is-busy'); }).then(function () { requestAnimationFrame(next); });
        })();
      }, 30);
    }
    function sizeCanvas(canvas, side) {
      var d = dprNow();
      canvas.width = Math.max(20, Math.round(side * d)); canvas.height = Math.max(20, Math.round(side * d));
      canvas.style.width = side + 'px'; canvas.style.height = side + 'px';
    }
    function smallSide(btn) { var tb = cssSize(btn); return Math.max(24, Math.min(tb.w * 0.8, (tb.h - 22) * 0.98)); }
    function bigSide() { var box = cssSize(E.big.parentNode); return Math.min(box.w * 0.86, box.h * 0.96); }
    function paintSmall(btn, L) {
      var canvas = qs(btn, 'canvas'), side = smallSide(btn);
      if (side < 20) return;
      sizeCanvas(canvas, side);
      paintLook(canvas, L, curVer(), { fill: 0.86 });
      btn.classList.remove('is-busy');
    }
    function paintBig(L) {
      if (!E.big) return;
      var side = bigSide();
      if (side < 20) return;
      sizeCanvas(E.big, side);
      paintLook(E.big, L, curVer(), { marks: marksFor(S.look), fill: 0.9 });
      E.yours.classList.remove('is-busy');
    }
    function paintPlaceholder(canvas, look, side) {
      if (side >= 20) sizeCanvas(canvas, side);
      else { var sz = cssSize(canvas.parentNode), d0 = dprNow(); canvas.width = Math.max(40, Math.round(sz.w * d0)); canvas.height = Math.max(40, Math.round(sz.h * d0)); }
      var W = canvas.width, H = canvas.height, c = canvas.getContext('2d'), s = Math.min(W, H) * 0.7, x = (W - s) / 2, y = (H - s) / 2;
      c.clearRect(0, 0, W, H);
      c.save();
      c.shadowColor = 'rgba(27,45,79,0.2)'; c.shadowBlur = W * 0.02; c.shadowOffsetY = W * 0.008;
      c.fillStyle = '#FFFFFF';
      if (look === 'circle') { c.beginPath(); c.arc(W / 2, H / 2, s / 2, 0, Math.PI * 2); c.fill(); }
      else if (look === 'square') { roundRectPath(c, x, y, s, s, s * 0.14); c.fill(); }
      else { roundRectPath(c, x + s * 0.05, y + s * 0.12, s * 0.9, s * 0.76, s * 0.3); c.fill(); }
      c.restore();
      c.fillStyle = '#5E6878'; c.font = '600 ' + Math.round(W * 0.05) + 'px Inter, system-ui, sans-serif'; c.textAlign = 'center'; c.textBaseline = 'middle';
      c.fillText('Your art', W / 2, H / 2);
    }

    /* === picking a file === */
    function chooseFile() { try { E.file.value = ''; } catch (e) { /* fine */ } E.file.click(); }
    function startOriginal(file, turn) {
      var rec = { state: 'saving', url: null, loaded: 0, total: file.size || 0, movedAt: Date.now() };
      var name = file.name || 'artwork';
      function go(tries) {
        return cloudUpload(cfg, file, name, cfg.cloud.originals, function (l, t) { rec.loaded = l; rec.total = t; rec.movedAt = Date.now(); })
          .catch(function (e) { if (tries < 1 && /network/.test(e.message)) return sleep(1500).then(function () { return go(tries + 1); }); throw e; });
      }
      rec.promise = go(0).then(function (url) {
        if (S.file && S.file.turn === turn) { rec.url = url; rec.state = 'done'; }
        return url;
      }, function () { rec.state = 'failed'; return null; });
      return rec;
    }
    function onFile(file) {
      if (!file) return;
      E.cartmsg.hidden = true;
      if (file.size > MAX_BYTES) {
        showCartMsg('That file is over 25 MB. Try a smaller copy, or send us a note and we\u2019ll help.', false);
        return;
      }
      var turn = ++S.turn;
      S.noFileYet = false;
      S.answers = {};
      S.look = 'die_cut';
      S.qtyOpen = false;
      S.art = null;
      layoutCache = {};
      S.file = { name: file.name || 'artwork', type: file.type, size: file.size, turn: turn };
      S.file.original = startOriginal(file, turn);
      E.before.hidden = true;
      E.after.hidden = false;
      E.filename.textContent = S.file.name;
      /* a new file: no pictures of the last one while this one opens */
      E.looks.map(function (b) { return qs(b, 'canvas'); }).concat(E.big ? [E.big] : []).forEach(function (c) {
        if (c && c.width) c.getContext('2d').clearRect(0, 0, c.width, c.height);
      });
      renderAll();
      paintLooks();
      decodeFile(file).then(function (dec) {
        if (turn !== S.turn) return null;
        return prepareArt(dec);
      }).then(function (art) {
        if (!art || turn !== S.turn) return;
        S.art = art;
        renderAll();
        paintLooks();
        startChecks(art, turn);
        /* the other sizes' cut shapes, quietly, for exact "Switch to" numbers */
        setTimeout(function () {
          if (turn !== S.turn) return;
          var jobs = [];
          SIZES.forEach(function (s) { ['die_cut', 'no_border'].forEach(function (lk) { jobs.push([lk, s]); }); });
          (function run(i) { if (i >= jobs.length || turn !== S.turn) return; layoutFor(jobs[i][0], jobs[i][1]).then(function () { if (i % 2) checksChanged(true); run(i + 1); }, function () { run(i + 1); }); })(0);
        }, 400);
      }).catch(function (err) {
        if (turn !== S.turn) return;
        S.art = err && err.noPreview ? { noPreview: true, checks: {} } : { failed: true, checks: {} };
        renderAll();
        paintLooks();
      });
    }
    function checksChanged(quiet) {
      renderFindings();
      renderTotal();
      paintLooks(!!quiet);
    }

    /* === answers === */
    function answer(key, what, label) {
      var f = lastFindings.filter(function (x) { return x.key === key; })[0];
      if (what === 'upload') { chooseFile(); return; }
      if (what === 'keep') {
        S.answers[key] = { choice: 'keep', metric: f ? f.metric : 0, label: label || 'Keep it as is', size: S.size, look: S.look, summary: f ? f.summary : '' };
      } else if (what.indexOf('size:') === 0) {
        var to = what.slice(5);
        S.answers[key] = { choice: 'switch', to: to, label: 'Switch to ' + inch(to), from: S.size, summary: f ? f.summary : '' };
        setSize(to);
        return;
      }
      checksChanged();
      var next = qs(E.lookbox, '.tsps-li:not(.is-answered) .tsps-pill');
      if (next) { try { next.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
    }
    function setSize(s) {
      if (SIZES.indexOf(s) < 0) return;
      S.size = s;
      if (!tierFor(S.size, S.qty)) { var l = tiers[S.size] || []; if (l.length) S.qty = l[0].qty; }
      renderAll();
      paintLooks();
    }

    /* === the order === */
    function artworkCheckText() {
      var art = S.art, parts = [];
      if (!art || art.noPreview || art.failed) return '';
      if (art.removed) parts.push(art.useRaw ? 'White box kept (they put it back)' : 'White box taken away');
      var fs = currentFindings();
      ['sharp', 'words', 'qr', 'details'].forEach(function (key) {
        var f = fs.filter(function (x) { return x.key === key && !x.ok; })[0], a = S.answers[key];
        if (f && a && a.choice === 'keep') parts.push(f.summary + ', ' + (key === 'sharp' || key === 'words' ? 'kept ' + inch(S.size) : key === 'qr' ? 'kept it' : 'kept it as is'));
        else if (!f && a && a.choice === 'switch') parts.push((a.summary || 'Saw a check') + ', switched to ' + inch(a.to));
      });
      if (art.checks.words && art.checks.words.failed) parts.push('Small words not checked (the word reader didn\u2019t load)');
      if (!checksDone()) parts.push('Check still running at add to cart');
      return parts.length ? parts.join(' \u00b7 ') : 'Looked good';
    }
    /* the sticker they picked, flat (no texture), see-through outside the cut */
    function designCanvas(minPx, maxPx) {
      var L = layoutNow(S.look, S.size), ver = curVer();
      if (!L || !ver) return null;
      var longIn = Math.max(L.wIn, L.hIn), px = clamp(Math.round(300 * longIn), minPx, maxPx), k = px / longIn;
      var c = makeCanvas(Math.ceil(L.wIn * k), Math.ceil(L.hIn * k));
      drawSticker(c.getContext('2d'), L, ver, k, 0, 0);
      return c;
    }
    /* for the order: 300 pixels per inch, kept between 1000 and 1500 px */
    function exportDesign() {
      var c = designCanvas(1000, 1500);
      if (!c) return Promise.reject(new Error('not ready'));
      return new Promise(function (ok, bad) { c.toBlob(function (b) { if (b) ok(b); else bad(new Error('no picture')); }, 'image/png'); });
    }
    function waitForOriginal(rec, onTick) {
      if (!rec || rec.state !== 'saving') return Promise.resolve(rec ? rec.url : null);
      var started = Date.now();
      return new Promise(function (ok) {
        (function tick() {
          if (rec.state !== 'saving') { ok(rec.url); return; }
          var waited = Date.now() - started, stalled = Date.now() - rec.movedAt;
          /* 20 seconds, longer while a big file is still moving (up to 90) */
          if ((waited > 20000 && stalled > 4000) || waited > 90000) { ok(null); return; }
          if (onTick && rec.total) onTick(Math.round(100 * rec.loaded / rec.total));
          setTimeout(tick, 250);
        })();
      });
    }
    function showCartMsg(text, calm) {
      E.cartmsg.textContent = text;
      E.cartmsg.classList.toggle('is-calm', !!calm);
      E.cartmsg.hidden = !text;
    }
    function nudge(el) {
      if (!el) return;
      el.classList.remove('is-nudge');
      void el.offsetWidth;
      el.classList.add('is-nudge');
      setTimeout(function () { el.classList.remove('is-nudge'); }, 1000);
    }
    function addToCart() {
      if (S.adding) return;
      showCartMsg('', false);
      var p = priceNow();
      if (!p || !p.tier.id) { showCartMsg('We couldn\u2019t find that size and amount. Please refresh the page, or send us a note.', false); return; }
      if (!S.file && !S.noFileYet) {
        var addHere = E.stageAdd && !E.before.hidden ? E.stageAdd : E.artpick;
        (E.stage && !E.before.hidden ? E.stage : addHere).scrollIntoView({ behavior: 'smooth', block: 'center' });
        nudge(addHere);
        showCartMsg('Choose your file first, or pick "Add it after you order".', true);
        return;
      }
      if (S.file && !S.art) { showCartMsg('One moment: we\u2019re still opening your file.', true); return; }
      /* the check is still running (the word reader's first download on a
         slow phone): wait for it, up to 15 seconds, so nobody misses a
         thing to look at */
      if (S.file && S.art && !S.art.noPreview && !S.art.failed && !checksDone() && !addToCart.waited) {
        var started = Date.now(), turnNow = S.turn;
        S.adding = true; E.cart.disabled = true; E.cart.textContent = 'Finishing the file check\u2026';
        (function wait() {
          if (turnNow !== S.turn) { S.adding = false; E.cart.disabled = false; renderTotal(); return; }
          if (checksDone() || Date.now() - started > 15000) {
            S.adding = false; E.cart.disabled = false; renderTotal();
            addToCart.waited = true;
            try { addToCart(); } finally { addToCart.waited = false; }
            return;
          }
          setTimeout(wait, 300);
        })();
        return;
      }
      if (S.file && S.art && !S.art.noPreview && !S.art.failed && openCount() > 0) {
        E.checks.scrollIntoView({ behavior: 'smooth', block: 'start' });
        nudge(E.checks);
        showCartMsg('Please pick an answer for each thing to look at (it goes with your order).', true);
        return;
      }
      if (E.rights && !E.rights.checked) {
        E.rightswarn.hidden = false;
        E.rightsbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        nudge(E.rightsbox);
        return;
      }
      S.adding = true;
      E.cart.disabled = true;
      var art = S.art, rec = S.file ? S.file.original : null;
      var props = { 'Quantity': fmtQty(p.tier.qty) + ' stickers' };
      var canDraw = art && !art.noPreview && !art.failed;
      function say(t) { E.cart.textContent = t; }
      say(S.file ? 'Saving your sticker\u2026' : 'Adding to cart\u2026');
      var designP = canDraw
        ? exportDesign().then(function (blob) {
          return cloudUpload(cfg, blob, 'sticker-design.png', cfg.cloud.designs, function (l, t) { say('Saving your sticker\u2026 ' + Math.round(100 * l / t) + '%'); })
            .catch(function () { return sleep(1200).then(function () { return cloudUpload(cfg, blob, 'sticker-design.png', cfg.cloud.designs); }); });
        }).catch(function () { return null; })
        : Promise.resolve(null);
      designP.then(function (designUrl) {
        return waitForOriginal(rec, function (pct) { say('Saving your file\u2026 ' + pct + '%'); }).then(function (origUrl) { return [designUrl, origUrl]; });
      }).then(function (urls) {
        var designUrl = urls[0], origUrl = urls[1];
        if (S.file && !designUrl && !origUrl) {
          var e = new Error('nothing saved'); e.userMsg = 'We couldn\u2019t save your file just now. Please try again in a moment.'; throw e;
        }
        if (designUrl) { props['_Design Image'] = designUrl; props['_Sticker Preview'] = designUrl; }
        if (origUrl) props['_Original File'] = origUrl;
        if (art && art.pdfReader) props['_PDF Reader'] = art.pdfReader;
        if (S.file) {
          props['Shape'] = SHAPE_PROP[S.look];
          var L = canDraw ? layoutNow(S.look, S.size) : null;
          if (L) props['Printed Size'] = round1(L.wIn) + '" x ' + round1(L.hIn) + '"';
          var chk = artworkCheckText();
          if (chk) props['Artwork check'] = chk;
          if (!canDraw) props['Artwork'] = art && art.noPreview ? 'Uploaded (' + extOf(S.file.name).toUpperCase() + ', no preview on the website)' : 'Uploaded (it did not open on the website)';
        } else {
          props['Artwork'] = 'Coming after checkout (they will add it on their order page)';
        }
        if (S.backs) {
          props['Print TS Logo on Back and save 10%?'] = 'Yes';
          props['You Saved'] = money(p.saved) + ' ' + (cfg.currency || 'USD') + ' (10% off)';
        }
        props['Artwork Rights'] = String(cfg.rightsRecord || 'Customer confirmed they own or have permission to print this artwork (Artwork Terms v1, DATE)').replace('DATE', new Date().toISOString().slice(0, 10));
        say('Adding to cart\u2026');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: p.tier.id, quantity: 1, properties: props }] })
        });
      }).then(function (res) {
        if (!res.ok) throw new Error('cart ' + res.status);
        return res.json();
      }).then(function () {
        E.cart.classList.add('is-done');
        say('\u2713 Added to cart!');
        var go = '/cart';
        if (S.backs && cfg.coupon) go = '/discount/' + encodeURIComponent(cfg.coupon) + '?redirect=/cart';
        setTimeout(function () { window.location.href = go; }, 700);
      }).catch(function (err) {
        S.adding = false;
        E.cart.disabled = false;
        E.cart.classList.remove('is-done');
        renderTotal();
        showCartMsg((err && err.userMsg) || 'That didn\u2019t go through. Please try again, or send us a note.', false);
      });
    }
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      S.adding = false; E.cart.disabled = false; E.cart.classList.remove('is-done'); renderTotal();
    });

    /* === the Let's talk! box, written for them === */
    function openHelp() {
      var rec = S.file ? S.file.original : null;
      var what = fmtQty(S.qty) + ' stickers, ' + inch(S.size) + (S.art && !S.art.noPreview && !S.art.failed ? ' ' + LOOK_WORDS[S.look] : '');
      function write(url) {
        var msg = 'Hi! I have a question about my artwork for Print Your Own stickers (' + what + ').\n\n';
        if (S.file) msg += 'My file: ' + (url || S.file.name + ' (still saving)') + '\n\n';
        var form = document.getElementById('tsFooterForm');
        if (window.TSFooter && window.TSFooter.openContact && form) {
          window.TSFooter.openContact();
          var box = form.querySelector('textarea[name="message"]');
          if (box && (!box.value || box.__tspsMine)) { box.value = msg; box.__tspsMine = true; }
          var nm = form.querySelector('input[name="name"]');
          if (nm) { try { (nm.value ? box : nm).focus({ preventScroll: true }); } catch (e) { /* fine */ } }
          return;
        }
        window.location.href = 'mailto:' + (cfg.shopEmail || 'amber@texturedstickers.com') + '?subject=' + encodeURIComponent('Question about my artwork') + '&body=' + encodeURIComponent(msg);
      }
      if (rec && rec.state === 'saving') {
        Promise.race([rec.promise, sleep(6000)]).then(function () { write(rec.url); });
      } else write(rec ? rec.url : null);
    }

    /* === PDF quote and the purchasing email === */
    function quoteLines() {
      var p = priceNow();
      if (!p) return null;
      var each = p.std / p.tier.qty;
      var shape = S.art && !S.art.noPreview && !S.art.failed ? ' ' + LOOK_WORDS[S.look] : '';
      return {
        item: 'Print Your Own textured stickers, ' + inch(S.size) + shape,
        qty: p.tier.qty, each: each, std: p.std, final: p.final, saved: p.saved,
        url: String(cfg.productUrl || location.origin + location.pathname).split('?')[0] + '?size=' + S.size + '&qty=' + p.tier.qty
      };
    }
    function mailHref() {
      var q = quoteLines();
      if (!q) return '#';
      var lines = ['Hi! Here\u2019s a quote for our stickers from Textured Stickers:', '', q.item,
        fmtQty(q.qty) + ' stickers: ' + money(q.std) + ' (' + money(q.each) + ' each)'];
      if (cfg.coupon) lines.push('With their 10% backing discount: ' + money(round2(q.std * 0.9)));
      lines.push('Shipping is figured at checkout.', '', 'Order here: ' + q.url,
        'Pay by card, or pay later by check or PO at checkout.',
        'Questions: ' + (cfg.shopEmail || 'amber@texturedstickers.com'));
      var body = lines.join('\r\n');
      return 'mailto:?subject=' + encodeURIComponent('Quote: ' + fmtQty(q.qty) + ' textured stickers (' + inch(S.size) + ')') + '&body=' + encodeURIComponent(body);
    }
    function pdfQuote() {
      var q = quoteLines();
      if (!q) return;
      var btn = qs(root, '[data-tsps-pdf]');
      if (btn) btn.textContent = 'making your PDF\u2026';
      /* a small picture of their sticker (a JPEG on white keeps the PDF light) */
      var pic = null, picP = Promise.resolve(null);
      if (S.art && !S.art.noPreview && !S.art.failed) {
        var dc = designCanvas(360, 520);
        if (dc) {
          var wc = makeCanvas(dc.width, dc.height), wx = wc.getContext('2d');
          wx.fillStyle = '#FFFFFF'; wx.fillRect(0, 0, wc.width, wc.height); wx.drawImage(dc, 0, 0);
          try { picP = Promise.resolve(wc.toDataURL('image/jpeg', 0.86)); } catch (e) { picP = Promise.resolve(null); }
        }
      }
      Promise.all([loadScript(LIBS.jspdf), picP]).then(function (r) {
        pic = r[1];
        var JS = window.jspdf && window.jspdf.jsPDF;
        if (!JS) throw new Error('pdf maker missing');
        var doc = new JS({ unit: 'pt', format: 'letter' }), M = 54, Wd = 612, y = 64;
        var today = utahToday(), dateTxt = today.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
        var qn = 'Q-' + today.getFullYear() + pad2(today.getMonth() + 1) + pad2(today.getDate()) + '-' + String(Date.now()).slice(-4);
        doc.setTextColor(27, 45, 79);
        doc.setFont('helvetica', 'bold'); doc.setFontSize(22); doc.text('Textured Stickers', M, y);
        doc.setFontSize(20); doc.text('Quote', Wd - M, y, { align: 'right' });
        doc.setFont('helvetica', 'normal'); doc.setFontSize(9.5); doc.setTextColor(94, 104, 120);
        y += 18;
        doc.text(String(cfg.shopAddress || ''), M, y); doc.text('Date: ' + dateTxt, Wd - M, y, { align: 'right' });
        y += 13;
        doc.text((cfg.shopPhone || '') + '  \u00b7  ' + (cfg.shopEmail || '') + '  \u00b7  texturedstickers.com', M, y); doc.text('Quote number: ' + qn, Wd - M, y, { align: 'right' });
        y += 30;
        doc.setDrawColor(226, 214, 198); doc.setLineWidth(1); doc.line(M, y, Wd - M, y);
        y += 22;
        doc.setTextColor(27, 45, 79); doc.setFont('helvetica', 'bold'); doc.setFontSize(10);
        doc.text('Description', M, y); doc.text('Qty', 360, y, { align: 'right' }); doc.text('Each', 450, y, { align: 'right' }); doc.text('Total', Wd - M, y, { align: 'right' });
        y += 8; doc.line(M, y, Wd - M, y); y += 18;
        doc.setFont('helvetica', 'normal'); doc.setFontSize(10.5);
        doc.text(q.item, M, y); doc.text(fmtQty(q.qty), 360, y, { align: 'right' }); doc.text(money(q.each), 450, y, { align: 'right' }); doc.text(money(q.std), Wd - M, y, { align: 'right' });
        y += 14; doc.setFontSize(9); doc.setTextColor(94, 104, 120);
        doc.text('Full color, printed right into our texture. Free digital proof before anything prints.', M, y);
        y += 22;
        if (S.backs) {
          doc.setFontSize(10.5); doc.setTextColor(27, 45, 79);
          doc.text('Save 10%: our tiny logo on the peel-off backing', M, y); doc.text('-' + money(q.saved), Wd - M, y, { align: 'right' });
          y += 20;
        }
        doc.line(300, y, Wd - M, y); y += 20;
        doc.setFont('helvetica', 'bold'); doc.setFontSize(13); doc.setTextColor(27, 45, 79);
        doc.text('Total', 360, y, { align: 'right' }); doc.text(money(S.backs ? q.final : q.std), Wd - M, y, { align: 'right' });
        y += 16; doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor(94, 104, 120);
        doc.text('Plus shipping, figured at checkout.' + (!S.backs && cfg.coupon ? ' With our logo on the backing: ' + money(round2(q.std * 0.9)) + '.' : ''), Wd - M, y, { align: 'right' });
        y += 34;
        if (pic) {
          try { doc.addImage(pic, 'JPEG', M, y, 110, 110 * (layoutNow(S.look, S.size).hIn / layoutNow(S.look, S.size).wIn)); } catch (e) { /* no picture */ }
        }
        var tx = pic ? M + 130 : M;
        doc.setTextColor(27, 45, 79); doc.setFont('helvetica', 'bold'); doc.setFontSize(11);
        doc.text('How to order', tx, y + 10);
        doc.setFont('helvetica', 'normal'); doc.setFontSize(10); doc.setTextColor(62, 74, 92);
        var lines = [
          'Order online: ' + q.url,
          'Pay by card, or pay later by check or PO at checkout.',
          'Tax exempt? Choose "Invoice Me Tax-Exempt" at checkout.',
          'Your digital proof comes after checkout. Nothing prints until you say it\u2019s perfect.',
          'Questions? ' + (cfg.shopEmail || '') + ' or ' + (cfg.shopPhone || '')
        ];
        var ly = y + 28;
        lines.forEach(function (t) { var wrapped = doc.splitTextToSize(t, Wd - M - tx); doc.text(wrapped, tx, ly); ly += 14 * wrapped.length; });
        doc.setFontSize(8.5); doc.setTextColor(94, 104, 120);
        doc.text('Valid for 30 days from ' + dateTxt + '. Reach out anytime: ' + (cfg.shopEmail || '') + '  \u00b7  ' + (cfg.shopPhone || ''), Wd / 2, 744, { align: 'center' });
        doc.text('Textured Stickers  \u00b7  a family print shop in Washington, Utah', Wd / 2, 758, { align: 'center' });
        doc.save('Textured-Stickers-Quote-' + q.qty + '-' + String(S.size).replace('.', '_') + 'in.pdf');
      }).catch(function () {
        window.print();
      }).then(function () { if (btn) btn.textContent = 'download a PDF quote'; });
    }

    /* === the example before a file (made the same way theirs will be) === */
    var example = null;
    function exampleArt() {
      var c = makeCanvas(960, 960), x = c.getContext('2d'), k = 4;
      x.scale(k, k);
      function rr(X, Y, Wd, Hd, R) { roundRectPath(x, X, Y, Wd, Hd, R); x.fill(); }
      x.fillStyle = '#8CCBC3';
      rr(68, 112, 106, 100, 34); rr(72, 52, 24, 90, 12); rr(99, 38, 24, 100, 12); rr(126, 46, 24, 96, 12); rr(152, 66, 22, 78, 11);
      x.save(); x.translate(48, 156); x.rotate(-38 * Math.PI / 180); x.translate(-48, -156); rr(36, 118, 24, 76, 12); x.restore();
      x.fillStyle = '#E9765B';
      [[84, 62], [111, 48], [138, 56], [163, 76], [40, 132]].forEach(function (p) { x.beginPath(); x.arc(p[0], p[1], 4, 0, Math.PI * 2); x.fill(); });
      x.fillStyle = '#1B3A4B'; x.textAlign = 'center'; x.textBaseline = 'alphabetic';
      x.font = '700 20px Fraunces, Georgia, serif';
      x.fillText('Take 5', 121, 160); x.fillText('Breaths', 121, 182);
      return c;
    }
    /* the hand, drawn here (waits a moment for the Fraunces font): the
       example of last resort, if no picture loads */
    function handExample() {
      var fontsP = (document.fonts && document.fonts.load) ? Promise.race([document.fonts.load('700 20px Fraunces'), sleep(2500)]) : Promise.resolve();
      return fontsP.then(function () { var c = exampleArt(); return { c: c, id: c.getContext('2d').getImageData(0, 0, c.width, c.height) }; });
    }
    /* a picture example (her otter with a "Print your artwork" sign, assets/ts-pyo-example.png,
       or "Example design" from the theme editor), made into the four looks
       the same way a customer's file is, 3" on its long side */
    function pictureExample(src) {
      return loadImage(src).then(function (img) {
        var w = img.naturalWidth, h = img.naturalHeight, s = Math.min(1, 900 / Math.max(w, h));
        var c = makeCanvas(w * s, h * s), x = c.getContext('2d');
        x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
        x.drawImage(img, 0, 0, c.width, c.height);
        return { c: c, id: x.getImageData(0, 0, c.width, c.height) };
      });
    }
    function startExample() {
      if (example || !E.example) return;
      example = { busy: true };
      /* the editor's picture first, then her art, then the hand */
      var sources = [cfg.exampleImage, cfg.exampleDefault].filter(Boolean);
      function label(which) { var l = E.example.getAttribute('data-label-' + which); if (l) E.example.setAttribute('aria-label', l); }
      function tryPicture(i) {
        if (i >= sources.length) { label('hand'); return handExample(); }
        return pictureExample(sources[i]).then(function (r) {
          if (sources[i] === cfg.exampleDefault && sources[i] !== cfg.exampleImage) label('default');
          return r;
        }, function () { return tryPicture(i + 1); });
      }
      var artP = tryPicture(0);
      Promise.all([artP, textureSettled(2500)]).then(function (res) {
        var c = res[0].c, id = res[0].id;
        return Analysis.call('prepare', { w: c.width, h: c.height, data: id.data });
      }).then(function (r) {
        var v = prepVersion(r.clean);
        return Analysis.call('enclosingCircle', { alpha: v.alpha, w: v.w, h: v.h }).then(function (m) {
          v.mec = m;
          return Promise.all(['die_cut', 'no_border'].map(function (lk) {
            return Analysis.call('cutField', { alpha: v.alpha, w: v.w, h: v.h, sizeIn: 3, bandIn: lk === 'die_cut' ? BAND_IN : 0, R: 150 });
          })).then(function (fs) {
            var saveArt = S.art;
            example = { v: v, layouts: {} };
            example.layouts.die_cut = fieldLayout('die_cut', '3', fs[0]);
            example.layouts.no_border = fieldLayout('no_border', '3', fs[1]);
            S.art = { clean: v, raw: v, border: { kind: 'transparent' }, removed: false, useRaw: false, checks: {} };
            example.layouts.circle = analyticLayout('circle', '3', v);
            example.layouts.square = analyticLayout('square', '3', v);
            S.art = saveArt;
            paintExample();
          });
        });
      }).catch(function () { example = null; });
    }
    function paintExample() {
      if (!example || !example.layouts || E.before.hidden) return;
      var stageLook = LOOKS.indexOf(S.exampleLook) >= 0 ? S.exampleLook : 'die_cut';
      var cv = E.example, box = cssSize(E.stageArt || E.stage), d = dprNow(), side = Math.min(box.w * 0.72, box.h * 0.94);
      if (side < 20) return;
      cv.width = Math.round(side * d); cv.height = Math.round(side * d);
      cv.style.width = side + 'px'; cv.style.height = side + 'px';
      paintLook(cv, example.layouts[stageLook], example.v, { fill: 0.9 });
      E.thumbs.forEach(function (t) {
        var lk = t.getAttribute('data-tsps-thumb'), c = qs(t, 'canvas');
        if (!c || LOOKS.indexOf(lk) < 0) return;
        var tb = cssSize(t), s2 = Math.max(30, tb.w * 0.78);
        c.width = Math.round(s2 * d); c.height = Math.round(s2 * d);
        paintLook(c, example.layouts[lk], example.v, { fill: 0.86 });
      });
    }
    function showExample(which) {
      S.exampleLook = which;
      E.thumbs.forEach(function (t) { var on = t.getAttribute('data-tsps-thumb') === which; t.classList.toggle('is-on', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var isPhoto = which === 'photo', isVideo = which === 'video';
      if (E.photo) E.photo.hidden = !isPhoto;
      if (E.video) {
        E.video.hidden = !isVideo;
        if (isVideo) {
          if (!E.video.src) E.video.src = E.video.getAttribute('data-src');
          try { var pr = E.video.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) { /* fine */ }
        } else { try { E.video.pause(); } catch (e) { /* fine */ } }
      }
      E.example.hidden = isPhoto || isVideo;
      if (!isPhoto && !isVideo) paintExample();
    }

    /* === wiring === */
    function renderAll() {
      renderSizes();
      renderQty();
      renderFindings();
      renderTotal();
    }
    function radioKeys(e, items, pick) {
      var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      if (!(e.key in keys)) return;
      var i = items.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var j = (i + keys[e.key] + items.length) % items.length;
      pick(items[j]);
      items[j].focus();
    }
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var b;
      if ((b = t.closest('[data-tsps-size]'))) { setSize(b.getAttribute('data-tsps-size')); return; }
      if ((b = t.closest('[data-tsps-qty]'))) { S.qty = parseInt(b.getAttribute('data-tsps-qty'), 10); S.qtyOpen = false; renderQty(); renderTotal(); if (S.file || S.noFileYet) E.qtyrow.focus(); return; }
      if ((b = t.closest('[data-tsps-qtymore]'))) { S.qtyMore = true; renderQty(); var on = qs(E.qtys, '.is-on'); if (on) on.focus(); return; }
      if (t.closest('[data-tsps-qtyrow]')) { S.qtyOpen = true; S.qtyMore = false; renderQty(); var on2 = qs(E.qtys, '.is-on'); if (on2) on2.focus(); return; }
      if (t.closest('[data-tsps-choose]') || t.closest('[data-tsps-change]')) { e.preventDefault(); chooseFile(); return; }
      if (t.closest('[data-tsps-stage]') && !S.file) { chooseFile(); return; }
      if (t.closest('[data-tsps-later]')) { S.noFileYet = true; renderAll(); return; }
      if ((b = t.closest('[data-tsps-look]'))) { S.look = b.getAttribute('data-tsps-look'); renderAll(); paintLooks(); return; }
      if ((b = t.closest('[data-tsps-do]'))) { answer(b.getAttribute('data-tsps-key'), b.getAttribute('data-tsps-do'), b.getAttribute('data-tsps-label')); return; }
      if (t.closest('[data-tsps-details]')) { S.detailsOpen = !S.detailsOpen; renderFindings(); var dt = qs(E.sum, '[data-tsps-details]'); if (dt) dt.focus(); return; }
      if ((b = t.closest('[data-tsps-reask]'))) { delete S.answers[b.getAttribute('data-tsps-reask')]; checksChanged(); return; }
      if (t.closest('[data-tsps-putback]')) { S.art.useRaw = true; renderAll(); paintLooks(); return; }
      if (t.closest('[data-tsps-takeaway]')) { S.art.useRaw = false; renderAll(); paintLooks(); return; }
      if (t.closest('[data-tsps-help]')) { openHelp(); return; }
      if (t.closest('[data-tsps-pdf]')) { pdfQuote(); return; }
      if ((b = t.closest('[data-tsps-thumb]'))) { showExample(b.getAttribute('data-tsps-thumb')); return; }
      if (t.closest('[data-tsps-cart]')) { addToCart(); return; }
      if (t.closest('[data-tsps-tolook]')) { e.preventDefault(); E.checks.scrollIntoView({ behavior: 'smooth', block: 'start' }); try { E.lookbox.focus({ preventScroll: true }); } catch (er) { /* fine */ } return; }
      if (t.closest('[data-tsps-stars]')) {
        var rv = document.getElementById('reviews');
        if (rv) { e.preventDefault(); rv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    });
    root.addEventListener('keydown', function (e) {
      if (e.target.closest('[data-tsps-sizes]')) radioKeys(e, E.sizes, function (b) { setSize(b.getAttribute('data-tsps-size')); });
      else if (e.target.closest('[data-tsps-looks]')) radioKeys(e, E.looks, function (b) { S.look = b.getAttribute('data-tsps-look'); renderAll(); paintLooks(); });
      else if (e.target.closest('[data-tsps-qtys]')) {
        var items = qsa(E.qtys, '[data-tsps-qty]');
        radioKeys(e, items, function (b) { S.qty = parseInt(b.getAttribute('data-tsps-qty'), 10); renderTotal(); items.forEach(function (x) { var o = x === b; x.classList.toggle('is-on', o); x.setAttribute('aria-checked', o); x.tabIndex = o ? 0 : -1; }); });
      }
    });
    if (E.backs) E.backs.addEventListener('change', function () { S.backs = E.backs.checked; renderTotal(); });
    if (E.rights) E.rights.addEventListener('change', function () { if (E.rights.checked) E.rightswarn.hidden = true; });
    E.file.addEventListener('change', function () { var f = E.file.files && E.file.files[0]; if (f) onFile(f); });
    /* drop a file anywhere on the page section */
    ['dragenter', 'dragover'].forEach(function (ev) {
      root.addEventListener(ev, function (e) {
        if (!e.dataTransfer || Array.prototype.indexOf.call(e.dataTransfer.types || [], 'Files') < 0) return;
        e.preventDefault();
        if (E.stage) E.stage.classList.add('is-drop');
        if (E.yours) E.yours.classList.add('is-drop');
      });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      root.addEventListener(ev, function (e) {
        if (E.stage) E.stage.classList.remove('is-drop');
        if (E.yours) E.yours.classList.remove('is-drop');
        if (ev === 'drop' && e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) { e.preventDefault(); onFile(e.dataTransfer.files[0]); }
      });
    });
    var resizeT = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () { if (S.file) paintLooks(); else if (example && example.layouts) paintExample(); }, 160);
    });

    /* dates from the Production dials */
    if (window.TSLead && window.TSLead.ready) window.TSLead.ready(function (lead) { S.lead = lead; renderDate(); });

    /* the theme editor: point out the old sections if they're still on */
    if (cfg.designMode) {
      var note = qs(root, '[data-tsps-editor-note]');
      if (note && (document.getElementById('pyoBuilder') || document.getElementById('pyo2-pricing') || document.querySelector('.sa-pyo-top__inner'))) note.hidden = false;
    }

    /* her real vinyl tiles: everything on screen is painted again once
       they're in (until then the stickers show flat, with their light and
       shadow) */
    loadTexture(cfg.texture, function () {
      if (S.file) paintLooks();
      else if (example && example.layouts) paintExample();
    });

    renderAll();
    /* the example starts once the section is near the screen */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); startExample(); } }, { rootMargin: '200px' });
      io.observe(root);
    } else startExample();

    root.__tsps = {
      state: S, tiers: tiers, cfg: cfg,
      findings: function () { return currentFindings(); },
      details: function () { return S.art && S.art.checks && S.art.checks.details ? detailsAt(S.look, S.size, verName()) : null; },
      checkText: artworkCheckText,
      layout: function () { return layoutNow(S.look, S.size); },
      mailHref: mailHref,
      ready: checksDone,
      texture: function () { return { state: TEX.state, mm: TEX.mm.slice(), tiles: Object.keys(TEX.sized) }; }
    };
  }

  function boot() { qsa(document, '[data-tsps]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-tsps]') : null;
    if (el) initRoot(el);
  });
  window.TSPYO = { version: '2026-10-31a', boot: boot };
})();
